export default {
  "common.login": "EINLOGGEN",
  "common.logout": "AUSLOGGEN",
  "common.logged-out": "Sie wurden ausgeloggt.",
  "common.log-in-portal": "Verwenden Sie das Portal zum Einloggen.",
  "common.undo": "rückgängig machen",
  "common.unknown": "unbekannt",
  "common.save-changes": "Änderungen speichern",
  "common.cancel": "Abbrechen",
  "common.accept": "Akzeptieren",
  "common.no-matching-tags": "Keine übereinstimmenden Tags",
  "common.create-tag": "Erstellen Sie einen neuen Tag",
  "common.subscriptionRequired": "Ihr Abonnement ist abgelaufen, gehen Sie zu Ihrem Konto, um Ihr Abonnement zu verlängern.",
  "common.alreadySubscribed": "Sie sind bereits abonniert.",
  "common.loading": "Laden...",
  "common.notFound": "Nicht gefunden",
  "common.done": "Fertig",
  "common.copy": "Kopieren",
  "common.copied": "Kopiert",
  "common.next": "Weiter",
  "common.back": "Zurück",
  "common.close": "Schließen",
  "common.open": "Öffnen",
  "common.save": "Speichern",
  "common.hide": "Verbergen",
  "common.retry": "Erneut versuchen",
  "common.refresh": "Aktualisieren",
  "common.save-template": "Als Vorlage speichern",
  "common.choose": "Auswählen",
  "common.apply": "Anwenden",
  "common.delete": "Löschen",
  "common.reload": "Neu laden",

  "app.update_available": "Eine neuere Version der App ist verfügbar.",
  "app.update_reload": "Jetzt neu laden",

  "menu.invitations": "EINLADUNGEN",
  "menu.portal": "PORTAL",
  "menu.faq": "FAQ",
  "menu.voicePlans": "Voice Plans",
  "menu.book": "Bücher",
  "menu.playlist": "Wiedergabeliste",
  "menu.portal_lower": "Übungsportal",
  "menu.menu": "Menü",
  "menu.language": "Sprache",
  "menu.settings": "Einstellungen",
  "menu.home": "Startseite",
  "menu.back": "Zurück",
  "menu.subscriptionRequired.tooltip": "Abonnement erforderlich für den Zugriff auf diese Funktion",
  "menu.portal.description": "Hier können Sie alle Gesangsübungen aus dem Universal Voice Guide abspielen",
  "menu.voicePlans.description": "Erstellen Sie hier einen Übungsplan mit Gesangsübungen für sich selbst oder für Ihre Schüler",
  "menu.playlist.description": "Erstellen Sie hier eine Wiedergabeliste Ihrer Lieblingsübungen, damit diese beim Training nacheinander abgespielt werden",
  "menu.book.description": "Digitale PDF-Versionen des Universal Voice Guide in verschiedenen Sprachen",
  "menu.account_and_subscription": "Konto und Abonnement",
  "menu.organization": "Organisationslizenz",
  "menu.pricing": "PREISE",
  "menu.organization_pricing": "Organisationspreise",

  "voicePlanList.students": "Studenten",
  "voicePlanList.teachers": "Lehrer",
  "voicePlanList.voiceplans": "Voice Plans",
  "voicePlanList.no-voiceplans": "Sie haben noch keine Voice Plans!",
  "voicePlanList.toast.delete-voiceplan": "{{name}} gelöscht",
  "voicePlanList.all": "Alle",
  "voicePlanList.add-new-voiceplan.a": "Sie können neue Voice Plans für sich selbst oder einen Studenten hinzufügen, indem Sie auf die Plus-Taste klicken",
  "voicePlanList.add-new-voiceplan.b": "in der unteren rechten Ecke.",
  "voicePlanList.manage-categories": "Tags verwalten",
  "voicePlanList.add-category": "Kategorie hinzufügen",
  "voicePlanList.edit-category": "Kategorie bearbeiten",
  "voicePlanList.category-name": "Kategoriename",
  "voicePlanList.category-name-placeholder": "z.B. Meine Studenten",
  "voicePlanList.category-tags": "Tags",
  "voicePlanList.category-match-rule": "Abgleichregel",
  "voicePlanList.match-all": "Alle Tags mussen ubereinstimmen",
  "voicePlanList.match-any": "Beliebiger Tag muss ubereinstimmen",
  "voicePlanList.filter": "Filter",
  "voicePlanList.filter-and-settings": "Filter & Einstellungen",
  "voicePlanList.categories": "Kategorien",
  "voicePlanList.manage-tags": "Tags verwalten",
  "voicePlanList.delete-tag": "Tag loschen",
  "voicePlanList.delete-tag-description": "Klicken Sie auf das X bei einem Tag, um es aus allen Voice-Plänen zu entfernen.",
  "voicePlanList.tag-deleted-undo": "Tag gelöscht. Rückgängig machen?",
  "voicePlanList.protected-tag": "System-Tag basierend auf der Rolle des Voice Plans. Es kann nicht gelöscht werden.",
  "voicePlanList.hide-system-tags": "System-Tags ausblenden",
  "voicePlanList.set-color": "Tag-Farbe festlegen",
  "voicePlanList.edit-tag-label": "Geben Sie einen Anzeigenamen für diesen Tag ein:",
  "voicePlanList.show-more": "Mehr anzeigen",
  "voicePlanList.show-less": "Weniger anzeigen",

  "playlistList.create-prompt": "Geben Sie einen Namen für die Wiedergabeliste ein:",
  "playlistList.rename-prompt": "Wiedergabeliste umbenennen",
  "playlistList.delete-confirm": "Sind Sie sicher, dass Sie diese Wiedergabeliste löschen möchten?",
  "playlistList.no-playlists": "Noch keine Wiedergabelisten",
  "playlistList.add-new-playlist.a": "Klicken Sie",
  "playlistList.add-new-playlist.b": "um eine Wiedergabeliste zu erstellen",

  "playlistView.edit": "Bearbeiten",
  "playlistView.playback": "Wiedergabe",
  "playlistView.playlist-items": "Wiedergabeliste Elemente",
  "playlistView.no-items": "Keine Elemente in der Wiedergabeliste",
  "playlistView.search-exercises": "Übungen Suchen",
  "playlistView.search-placeholder": "Übungen suchen...",
  "playlistView.play": "Abspielen",
  "playlistView.stop": "Stoppen",
  "playlistView.add-exercise": "Übung hinzufügen",
  "playlistView.add-tts": "TTS hinzufügen",
  "playlistView.add-recording": "Stimme hinzufügen",
  "playlistView.playlist-name": "Wiedergabeliste Name",
  "playlistView.by": "von",
  "playlistView.is-private": "Diese Wiedergabeliste ist privat oder wurde vom Autor entfernt.",
  "playlistView.back-to-library": "Zurück",
  "playlistView.add-to-playlist": "Zur Wiedergabeliste hinzufügen",
  "playlistView.add-first-item": "Übungen hinzufügen",
  "playlistView.empty-description": "Fügen Sie Übungen, Text-to-Speech-Anweisungen oder Sprachaufnahmen hinzu, um Ihre Übungsroutine aufzubauen.",
  "playlistView.empty-title": "Ihre Wiedergabeliste ist leer",

  "toast.share-linked-copied": "Teilen-Link in die Zwischenablage kopiert",

  "playlistShare.title": "Wiedergabeliste teilen",
  "playlistShare.visibility": "Sichtbarkeit",
  "playlistShare.only-me": "Nur ich",
  "playlistShare.with-link": "Jeder mit dem Link",
  "playlistShare.make-public": "Wiedergabeliste öffentlich machen",
  "playlistShare.link": "Teilen-Link",
  "playlistShare.help-text": "Das Öffentlichmachen einer Wiedergabeliste ermöglicht es anderen, sie zu favorisieren. Alle Änderungen, die du vornimmst, sind sofort für alle sichtbar, die sie gespeichert hebben.",
  "playlistShare.favorite-count": "Diese Wiedergabeliste hat {count} Favoriten.",
  "playlistShare.private-notice": "Diese Wiedergabeliste ist derzeit privat. Nur du kannst sie sehen.",
  "playlistShare.private-impact": "{count} Benutzer, die deine Wiedergabeliste favorisiert haben, können sie nicht mehr sehen.",

  "voicePlan.no-lessons": "Sie haben noch keine Lektionen!",
  "voicePlan.no-lessons-description.a": "Sie können eine neue Lektion für sich selbst oder einen Studenten hinzufügen, indem Sie auf die Plus-Taste klicken",
  "voicePlan.no-lessons-description.b": "rechts, unter dem Teilen-Symbol.",
  "voicePlan.wait-for-teacher": "Warten Sie, bis Ihr Lehrer Lektionen und Aufgaben hinzufügt!",
  "voicePlan.not-found": "Voice Plan nicht gefunden",
  "voicePlan.not-found-description": "Der Voice Plan, den Sie suchen, existiert nicht oder wurde entfernt.",
  "voicePlan.back-to-list": "Zurück zu den Voice Plans",

  "lesson.explanation.a": "Sie können",
  "lesson.explanation.b": "den Titel bearbeiten",
  "lesson.explanation.c": "durch Antippen",
  "lesson.explanation.d": "Löschen Sie diese Lektion, indem Sie auf das",
  "lesson.explanation.e": "fügen Sie neue",
  "lesson.explanation.f": "Aufgaben",
  "lesson.explanation.g": "hinzu, durch Anklicken des",
  "lesson.explanation.h": "Oder wählen Sie eine Vorlage aus: ",
  "lesson.select-template": "Vorlage auswählen",
  "lesson.global-template-label": "Global",
  "lesson.global": "Global",
  "lesson.no-templates": "Keine Vorlagen verfügbar",
  "lesson.wait-for-teacher": "Warten Sie, bis Ihr Lehrer Aufgaben hinzufügt!",
  "lesson.toast.deleted-lesson": "Die Lektion gelöscht",
  "lesson.prompt-name": "Geben Sie einen Namen für diese Lektion ein",
  "lesson.loading-exercises": "Übungen werden geladen...",
  "lesson.exercises-load-error": "Übungen konnten nicht geladen werden. Andere Voice Plans in diesem Tab können bis zum erneuten Versuch ebenfalls hängen.",
  "lesson.prompt-template-name": "Geben Sie einen Namen für diese Vorlage ein",
  "lesson.template-name": "Vorlagenname",
  "lesson.ask-global": "Möchten Sie eine globale Vorlage hinzufügen?",
  "lesson.edit-name": "Lektionsnamen bearbeiten",
  "lesson.remove": "Lektion entfernen",
  "lesson.add": "Lektion hinzufügen",
  "lesson.save-template": "Als Vorlage speichern",
  "lesson.add-stemprofiel": "Stimmenprofil hinzufügen",
  "lesson.remove-stemprofiel": "Stimmenprofil entfernen",
  "lesson.remove-stemprofiel-confirm": "Sind Sie sicher, dass Sie das Stimmenprofil dieser Lektion löschen möchten? Dadurch werden alle ausgefüllten Daten gelöscht.",

  "assignment.toast.deleted-assignment": "Die Aufgabe gelöscht",

  "voicePlanListItem.namePrompt": "Geben Sie einen Namen für diesen Voice Plan ein",

  "voicePlanInvitation.give-voice-plan-name": "Geben Sie Ihrem Voice Plan einen Namen",
  "voicePlanInvitation.accept": "Annehmen",
  "voicePlanInvitation.decline": "Ablehnen",
  "voicePlanInvitation.open": "Öffnen",

  "newAssignmentModal.add-assignment": "Aufgabe hinzufügen",
  "newAssignmentModal.search-placeholder": "Geben Sie die Übungsnummer oder ein Stichwort zur Suche ein...",
  "newAssignmentModal.description": "Beschreibung",
  "newAssignmentModal.language": "Sprache",
  "newAssignmentModal.language-explanation": "Universal Voice wurde in mehreren Sprachen veröffentlicht, und jede Sprache hat ihre eigene Nummerierung. Wählen Sie die gewünschte Sprache aus.",
  "newAssignmentModal.not-teacher": "Sie müssen ein Lehrer sein, um Aufgaben zu bearbeiten.",
  "newAssignmentModal.template-title-qustion": "Was ist der Titel dieser Vorlage?",
  "newAssignmentModal.template-description-qustion": "Was ist die Beschreibung dieser Vorlage?",
  "newAssignmentModal.template-title-description-required": "Titel und Beschreibung sind erforderlich, um eine Vorlage zu speichern.",

  "invitations.no-invitations": "Sie haben keine Einladungen.",
  "invitations.no-invitations-description.a": "Sie können andere Personen als",
  "invitations.no-invitations-description.b": "Ihren Studenten einladen",
  "invitations.no-invitations-description.c": "indem Sie auf die Plus-Taste klicken",
  "invitations.no-invitations-description.d": "in der unteren rechten Ecke.",
  "invitations.invited-by": "Eingeladen von: {{name}}",
  "invitations.pending-title": "Offene Einladungen",
  "invitations.accepted-title": "Angenommene Einladungen",

  "invitation.accept": "Akzeptieren",
  "invitation.decline": "Ablehnen",
  "invitation.invited-badge": "Eingeladen",

  "invite.title": "Personen einladen",
  "invite.email-placeholder": "E-Mail-Adresse eingeben",
  "invite.can-edit": "Kann bearbeiten?",
  "invite.send": "Einladung senden",
  "invite.pending": "Ausstehend",
  "invite.accepted": "Akzeptiert",
  "invite.remove": "Entfernen",
  "invite.error": "Einladung fehlgeschlagen",
  "invite.no-invitees": "Noch niemand eingeladen",
  "invite.migrate-title": "Teilen aktivieren",
  "invite.migrate-description": "Dieser Voice Plan verwendet das alte Freigabesystem. Aktivieren Sie es, um zu sehen, wer Zugriff hat, und neue Personen einzuladen. Vorhandene Benutzer mit Zugriff werden automatisch hinzugefügt.",
  "invite.migrate-enable": "Teilen aktivieren",
  "invite.migrate-success": "Teilen aktiviert! Die folgenden Personen haben Zugriff:",
  "invite.migrate-users-found": "Benutzer mit Zugriff",
  "invite.migrate-continue": "Weiter zum Einladen",

  "exercise_editor.no_permission": "Sie haben keine Berechtigung, Übungen zu veröffentlichen. Bitte kontaktieren Sie den Administrator.",
  "exercise_editor.title": "Übungseditor",
  "exercise_editor.description": "Wenn Sie eine Übung bearbeiten, wird sie nicht sofort in der App oder im Portal veröffentlicht.",
  "exercise_editor.language": "Sprache",
  "exercise_editor.check_changes": "Auf Änderungen prüfen",
  "exercise_editor.checking": "Änderungen werden geprüft...",
  "exercise_editor.publish_app": "In App veröffentlichen",
  "exercise_editor.no_changes": "Es gibt keine ausstehenden Änderungen",
  "exercise_editor.no_changes_note": "Es kann bis zu einer Minute dauern, bis Änderungen erkannt werden.",
  "exercise_editor.publish_portal": "Im Portal veröffentlichen",
  "exercise_editor.publish_app_first": "Zuerst in App veröffentlichen",
  "exercise_editor.search_placeholder": "Beginnen Sie mit der Eingabe, um eine Übung zu finden",
  "exercise_editor.new": "Neue Übung",
  "exercise_editor.save": "Speichern",
  "exercise_editor.clear": "Löschen",
  "exercise_editor.autocomplete_hint": "Hinweis: Nur veröffentlichte Übungen werden autovervollständigt.",
  "exercise_editor.not_found": "Übung {{id}} nicht gefunden",
  "exercise_editor.previous": "Vorherige",
  "exercise_editor.next": "Nächste",
  "exercise_editor.chapter": "Kapitel {{chapter}}",
  "exercise_editor.chapter_more": "Mehr",

  "faq.title": "FAQ",
  "faq.question1": "Wie kann ich den Namen eines Voice Plans bearbeiten oder löschen?",
  "faq.answer1": "Drücken Sie lange auf den Namen des Voice Plans in der Voice Plan-Liste, um das Kontextmenü zu öffnen. In diesem Menü können Sie den Namen des Voice Plans bearbeiten oder den Voice Plan vollständig löschen.",
  "faq.question2": "Wie kann ich eine Lektion bearbeiten und sortieren?",
  "faq.answer2": "Tippen Sie auf die Aufgabennummer oder das Symbol oben in der Aufgabe, um das Kontextmenü aufzurufen. In diesem Menü können Sie die Aufgabe bearbeiten, die Aufgabe löschen oder die Aufgabe an eine andere Position verschieben.",
  "faq.qas": [
    {
      "question": "Wie kündige ich mein Abonnement?",
      "answer": 'Du kannst dein Abonnement kündigen, indem du zu deinen <a href="/settings">Kontoeinstellungen</a> gehst und auf die rote Kündigen-Taste klickst. Dein Abonnement bleibt bis zum Ende deines aktuellen Abonnementzeitraums aktiv. <br /><img src="images/faq/cancel_abo_de.png" alt="alt_text" title="Abonnement kündigen"/>',
    },
    {
      "question": "Wie kann ich den Namen eines Voice Plans bearbeiten oder löschen?",
      "answer": "Drücken Sie lange auf den Namen des Voice Plans in der Voice Plan-Liste, um das Kontextmenü zu öffnen. In diesem Menü können Sie den Namen des Voice Plans bearbeiten oder den Voice Plan vollständig löschen."
    },
    {
      "question": "Wie kann ich eine Lektion bearbeiten und sortieren?",
      "answer": "Tippen Sie auf die Aufgabennummer oder das Symbol oben in der Aufgabe, um das Kontextmenü aufzurufen. In diesem Menü können Sie die Aufgabe bearbeiten, die Aufgabe löschen oder die Aufgabe an eine andere Position verschieben.<img src=\"/images/assignment_example.png\" alt=\"assignment example\" />"
    },
    {
      question: 'Wie erstelle ich einen Voice Plan für mich selbst? / Wie lade ich einen Schüler ein?',
      answer: 'Wenn Sie einen Voice Plan für sich selbst oder für Ihren Schüler hinzufügen möchten, klicken Sie auf das orangefarbene Symbol mit dem weißen Pluszeichen. Sie gelangen zu einem nächsten Bildschirm, auf dem Sie den Titel des Voice Plans eingeben können. Ist dieser Voice Plan für Ihren Schüler? Geben Sie dann die E-Mail-Adresse Ihres Schülers ein und klicken Sie auf \'Schüler einladen\'. Möchten Sie einen Voice Plan für sich selbst erstellen, geben Sie dann den Titel ein und klicken Sie anschließend auf \'Für mich erstellen\'. <img src="images/faq/hoe_maak_ik_een_voiceplan.png" alt="alt_text" title="image_tooltip">'
    },
    {
      question: 'Voice Plan umbenennen, Tags hinzufügen oder entfernen',
      answer: 'Möchten Sie einen Voice Plan umbenennen, ihm Tags hinzufügen oder ihn löschen? Klicken Sie dann auf die drei Punkte rechts neben dem Voice Plan. <img src="images/faq/voiceplan_hernoemen.png" alt="alt_text" title="image_tooltip"> <ul><li>Löschen: Klicken Sie auf das \'Mülleimersymbol\'</li><li> Umbenennen: Klicken Sie auf das \'Notizbuchsymbol\' und geben Sie dem Plan einen neuen Titel</li><li> Tag hinzufügen: Klicken Sie auf das \'Tag\'-Symbol. Geben Sie den Namen des Tags ein, den Sie ihm geben möchten.</li></ul>'
    },
    {
      question: 'Wie füge ich eine Lektion hinzu? Und wie gebe ich ihr einen Namen?',
      answer: 'Möchten Sie innerhalb eines Voice Plans eine oder mehrere Lektionen erstellen, klicken Sie auf das orangefarbene Symbol mit dem weißen Pluszeichen. Sofort wird eine Lektion erstellt, mit dem heutigen Datum als Titel. Möchten Sie dieser Lektion einen bestimmten Namen geben? Klicken Sie dann auf das Notizbuchsymbol, um den Titel beispielsweise in \'Belting\' oder \'Entwicklung des Tonumfangs\' zu ändern. <img src="images/faq/hoe_voeg_ik_een_les_toe.png" alt="alt_text" title="image_tooltip"><img src="images/faq/hoe_voeg_ik_een_les_toe_2.png" alt="alt_text" title="image_tooltip">'
    },
    {
      question: 'Wie füge ich eine Übung hinzu? Wie suche ich eine Übung in der Datenbank?',
      answer: 'Wenn Sie eine Übung zu Ihrem Lektionsplan hinzufügen möchten, klicken Sie auf das orangefarbene Pluszeichen.<img src="images/faq/hoe_voeg_ik_een_oefening_toe.png" alt="alt_text" title="image_tooltip">Ein Bildschirm erscheint. Möchten Sie eine Übung aus dem Universal Voice Portal hinzufügen? Geben Sie die Nummer der Übung ein, zum Beispiel \'005\'. Die Übung erscheint, klicken Sie darauf und drücken Sie \'Änderungen speichern\', um Ihre Übung zu speichern. <img src="images/faq/hoe_voeg_ik_een_oefening_toe_2.png" alt="alt_text" title="image_tooltip"> Möchten Sie spezifische Anweisungen oder eine zusätzliche Beschreibung zu der Übung hinzufügen? Schreiben Sie dann in das Textfeld eine Anweisung wie z.B. "Achten Sie darauf, in der klassischen Haltung zu bleiben." oder "Versuchen Sie, jede Note mit gleichem Maße an Helligkeit zu singen. Wissen Sie im Voraus nicht, welche Übung Sie hinzufügen möchten? Sie können auch die Suchfunktion verwenden, um nach der gewünschten Übung zu suchen. Sie können zum Beispiel nach \'Quinte\' suchen, dann werden alle Übungen mit dem Tonumfang Quinte angezeigt. Oder tippen Sie \'Lippenflattern\' ein, dann werden alle Übungen angezeigt, die einen Lippenflattern enthalten. Wählen Sie eine dieser Übungen aus und klicken Sie auf \'Änderungen speichern\'. <img src="images/faq/hoe_voeg_ik_een_oefening_toe_3.png" alt="alt_text" title="image_tooltip">Denken Sie daran, dass jede Übung eine spezifische Nummer hat. Diese Nummer entspricht dem Kapitel, in dem sie steht. Übung 411 stammt aus Kapitel 4 (Speech), Übung 523 stammt aus Kapitel 5 (Belting). Übung 1121 stammt aus Kapitel 11 (Gesundheit).'
    },
    {
      question: 'Ich möchte eine Übung anpassen/entfernen, wie mache ich das?',
      answer: 'Möchten Sie eine Übung in Ihrem Lektionsplan anpassen? Klicken Sie dann auf den orangefarbenen Titel der Übung, zum Beispiel 005 (oder falls kein Titel angezeigt wird, auf das orangefarbene Symbol). Durch Klicken auf die Pfeile können Sie die Übung höher oder niedriger im Lektionsplan platzieren. Möchten Sie die Übung löschen? Klicken Sie dann auf das Mülleimersymbol. Möchten Sie die Übung anpassen? Klicken Sie dann auf das Notizbuchsymbol.<img src="images/faq/oefening_aanpassen.png" alt="alt_text" title="image_tooltip">'
    },
    {
      question: 'Ich möchte eine Karaoke-Track von YouTube oder Spotify hinzufügen, wie mache ich das?',
      answer: 'Klicken Sie in einem Voice Plan auf das orangefarbene Pluszeichen. Anstelle eine Übung aus der Datenbank zu suchen, klicken Sie nun im Textfeld auf \'Einfügen\'. Klicken Sie dann auf Link. Fügen Sie die URL des entsprechenden Karaoke-Tracks ein und klicken Sie auf \'Änderungen speichern\'.<img src="images/faq/ik_wil_een_karaoketrack.png" alt="alt_text" title="image_tooltip">'
    },
    {
      question: 'Mein Lehrer hat mich eingeladen, wo finde ich die Einladung?',
      answer: 'Oben rechts in der App sehen Sie ein Menü. Dort finden Sie den Abschnitt \'Einladungen\'. Wenn Sie darauf klicken, sehen Sie alle Lektionspläne, zu denen noch eine Einladung aussteht. Steht hier keine Einladung? Dann haben Sie entweder den Voice Plan bereits in Ihrer Liste oder fragen Sie erneut, ob der Lehrer Sie einladen möchte. <img src="images/faq/mijn_docent_heeft_mij.png" alt="alt_text" title="image_tooltip">'
    },
    {
      id: 'share-voice-plan',
      question: 'Wie kann ein Lehrer einen Voice Plan mit einem Schüler über das neue System teilen?',
      answer: 'Der Lehrer öffnet den Voice Plan in der App, klickt oben auf den orangefarbenen Button \'Mensch einladen\' (das Symbol mit der Person und dem Pluszeichen), gibt die E-Mail-Adresse des Schülers ein und klickt auf \'Einladung senden\'. Der Schüler sieht die Einladung dann in seiner eigenen App unter dem Menü <b>Einladungen</b> (oben rechts in der Ecke), wo er sie annehmen kann.'
    }
  ],
  "createVoicePlan.title": "Erstellen Sie einen Voice Plan",
  "createVoicePlan.send-this-invite-line": "Senden Sie diesen Einladungslink an Ihren Studenten:",
  "createVoicePlan.voice-plan-name": "Name des Voice Plan",
  "createVoicePlan.name-for-student ": "Ein Name, den Sie für diesen Studenten verwenden möchten",
  "createVoicePlan.invite": "Einladen",
  "createVoicePlan.create-for-myself": "Für mich selber erstellen",
  "createVoicePlan.create-for-student-or-yourself": "Erstellen Sie einen Voice Plan für sich selbst oder für einen Studenten!",
  "createVoicePlan.name-for-student-or-self ": "Ein Name, den Sie für den Studenten oder sich selbst verwenden möchten",
  "createVoicePlan.email-to-add": "E-Mail, die Sie hinzufügen möchten",
  "createVoicePlan.add": "Hinzufügen",
  "createVoicePlan.students": "Studenten",
  "createVoicePlan.name-required": "Bitte geben Sie einen Namen für diesen Voice Plan ein",
  "createVoicePlan.subtitle": "Erstellen Sie einen neuen Voice Plan für sich selbst oder einen Schüler",
  "createVoicePlan.basic-info": "Grundinformationen",
  "createVoicePlan.name": "Name des Voice Plans",
  "createVoicePlan.name-placeholder": "z.B. Belting-Übungen - Hans",
  "createVoicePlan.invite-people": "Personen einladen",
  "createVoicePlan.invite-description": "Sie können optional Personen zu diesem Voice Plan einladen. Überspringen Sie diesen Schritt, wenn Sie später einladen möchten.",
  "createVoicePlan.role": "Rolle",
  "createVoicePlan.role-both": "Lehrer & Schüler",
  "createVoicePlan.role-teacher": "Lehrer",
  "createVoicePlan.role-student": "Schüler",
  "createVoicePlan.tags": "Tags",
  "createVoicePlan.add-tags": "Fügen Sie Tags hinzu, um Ihre Voice Plans zu organisieren",
  "createVoicePlan.tag-placeholder": "Geben Sie einen Tag ein und drücken Sie Enter",
  "createVoicePlan.quick-categories": "Schnell aus favorisierten Tags hinzufügen",
  "createVoicePlan.review": "Überprüfen",
  "createVoicePlan.create": "Voice Plan erstellen",

  "createVoicePlan.student-has-no-account": "Student hat noch kein Konto",
  "createVoicePlan.student-has-an-account": "Student hat ein Konto.",
  "createVoicePlan.invite-students": "Studenten einladen",
  "createVoicePlan.invite-student": "Student einladen",

  "createVoicePlan.description.a": "Nachdem Sie diesen Voice Plan benannt haben, können Sie die E-Mails der Studenten hinzufügen, die Sie einladen möchten.",
  "createVoicePlan.description.b": "Wenn der Student",
  "createVoicePlan.description.c": "ein Konto hat",
  "createVoicePlan.description.d": ", wird er dem Voice Plan hinzugefügt.",
  "createVoicePlan.description.e": "Wenn sie",
  "createVoicePlan.description.f": "noch kein Konto haben",
  "createVoicePlan.description.g": ", sehen sie die Einladung, sobald sie sich einloggen.",
  "createVoicePlan.description.h": "Wenn Sie einen Voice Plan für",
  "createVoicePlan.description.i": "sich selbst",
  "createVoicePlan.description.j": "erstellen möchten, geben Sie ihm einfach einen Namen und klicken Sie auf 'Für mich erstellen'.",

  "invitation.title": "Sie wurden eingeladen, einem Voice Plan beizutreten",
  "invitation.description.a": "Geben Sie ihm einen Namen (den Namen Ihres",
  "invitation.description.b": "Lehrers",
  "invitation.description.c": "vielleicht?)",
  "invitation.description.d": "wählen Sie die Rolle, die Sie übernehmen möchten",
  "invitation.description.e": "und klicken Sie auf Akzeptieren!",
  "invitation.a-name-for-this-voice-plan": "Ein Name, den Sie für diesen Voice Plan verwenden möchten",

  "invitation.student": "Schüler",
  "invitation.teacher": "Lehrer",
  "invite.banner.title": "Neue Art der Freigabe von Voice Plans",
  "invite.banner.description": "Wir haben eine neue, sichere Methode eingeführt, um Voice Plans direkt zu teilen. Sie sehen eine schreibgeschützte Vorschau dieses Voice Plans.",
  "invite.banner.student-notice": "Um Audio aufzunehmen, Übungen zu machen oder diesen Voice Plan vollständig zu nutzen, bitten Sie Ihren Lehrer, Sie über die neue E-Mail-Einladungsfunktion in der App einzuladen.",
  "invite.banner.teacher-notice": "Wenn Sie der Lehrer/Ersteller dieses Plans sind, öffnen Sie diesen Voice Plan in Ihrer App, klicken Sie oben auf das orangefarbene Person-Plus-Symbol, geben Sie die E-Mail des Schülers ein und klicken Sie auf 'Einladung senden'.",
  "invite.banner.faq-link": "FAQ-Anleitung anzeigen",

  "inlineTagsEditor.tag-color-prompt": "Tag Farbe",
  "inlineTagsEditor.tag-removed": "Tag entfernt",
  "voicePlanList.filter-by-tags": "Suche nach Tags",
  "voicePlanList.search-by-name": "Suche nach Namen",
  "voicePlanList.tags-active": "Tags aktiv",
  "voicePlanList.other": "Andere",

  "login.login": "EINLOGGEN",
  "login.email": "E-Mail-Adresse",
  "login.userid": "User ID",
  "login.password": "Passwort",
  "login.forgot": "Passwort vergessen?",
  "login.no-account": "NOCH KEIN KONTO?",
  "login.the-place": "der ideale Ort, um deine Stimme online zu trainieren",
  "login.more-than": "über 1400 Übungen",
  "login.try-free": "JETZT 2 WOCHEN KOSTENLOS TESTEN",
  "login.make-account": "EIN KONTO ERSTELLEN",
  "login.uvi-title": "Das Universal Voice Portal",
  "login.uvi-text": `Das Universal Voice Portal ist der Ort, an dem du deine Stimme online trainieren kannst. Was ist das?
  Alle Übungen (mehr als 1400) aus dem Universal Voice Guide sind nach verschiedenen Stilen kategorisiert. Eine
  ideale Lernumgebung, um schnell und effizient an deiner Sprache, Belting, Flüstern, Klassik oder Effekten zu arbeiten.
  Zu jeder Übung gibt es eine vorgesungene Beispielversion eines Mannes und einer Frau mit instrumentalen Tracks in
  verschiedenen Tonlagen, sodass jede Übung für jede Stimme geeignet ist. Für jedes Ziel, zum Beispiel lauter singen,
  gibt es auch mehrere Übungen mit steigendem Schwierigkeitsgrad. Also geeignet sowohl für Anfänger als auch für
  professionelle Sänger. Wenn dein Ziel ist, höher, tiefer, lauter, mit mehr Vibrato oder Dunkelheit zu singen, dann bist du im
  Universal Voice Portal genau richtig.`,
  "login.register-page": "14864",
  "login.login-with-google": "Mit Google anmelden",
  "login.login-with-wordpress": "Mit Wordpress anmelden",
  "login.login-with-password": "Einloggen",
  "login.login-with-email": "Über E-Mail einloggen",
  "login.email-login-link": "Login-Link per E-Mail senden",
  "login.email-required": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "login.sending-email-link": "Login-Link wird gesendet...",
  "login.email-link-sent": "Ein Login-Link wurde an {{email}} gesendet. Überprüfen Sie Ihre E-Mail und klicken Sie auf den Link, um sich anzumelden.",
  "login.wrong-password": "Diese Kombination aus E-Mail und Passwort ist ungültig.",
  "login.start-migration": "Starten Sie die Konto-Migration",
  "login.unknown-error": "Ein unbekannter Fehler ist aufgetreten, bitte versuchen Sie es später erneut. Oder kontaktieren Sie den Support.",
  "login.migration.1": `<p>Wir sind ständig bemüht, unsere Website zu verbessern und Ihnen den besten Service zu bieten. Aus diesem Grund haben wir einen neuen Anbieter für die Überprüfung Ihres Kontos gewechselt. Aus diesem Grund müssen Sie Ihr Passwort zurücksetzen.</p>`,
  "login.migration.2": "Mehr Informationen",
  "login.migration.3": `<p>Es ist sehr einfach, Ihr Passwort zurückzusetzen. Befolgen Sie einfach diese Schritte:</p>
    <ol>
        <li>Klicken Sie auf den Link unten, um zur Seite zur Passwortänderung zu gelangen.</li>
        <li>Geben Sie Ihre E-Mail-Adresse ein und klicken Sie auf "Senden".</li>
        <li>Sie erhalten eine E-Mail mit einem Link, um ein neues Passwort zu wählen.</li>
        <li>Klicken Sie auf den Link und geben Sie Ihr neues Passwort ein.</li>
        <li>Bestätigen Sie Ihr neues Passwort und klicken Sie auf "Speichern".</li>
        <li>Sie können sich nun mit Ihrem neuen Passwort einloggen.</li>
    </ol>
    <p>Wir hoffen, dass Sie mit dieser Änderung zufrieden sind und weiterhin unsere Website genießen. Wenn Sie Fragen oder Probleme haben, zögern Sie nicht, uns zu kontaktieren.</p>
    <p>Vielen Dank für Ihr Verständnis und Ihr Vertrauen in uns.</p>`,
  "login.email-sent": "Wenn ein Konto mit der angegebenen E-Mail-Adresse existiert, wurde eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts gesendet.",
  "login.reset-password": "Passwort zurücksetzen",
  "login.need-to-migrate": "Ihr Konto muss migriert werden, um fortzufahren. Klicken Sie zum Starten auf die Schaltfläche unten, um Ihr Passwort zurückzusetzen. Der gesamte Vorgang dauert nur einen kurzen Moment.",
  "login.you-will-be-migrating": "Sie werden {{email}} migrieren",
  "login.street": "Straße",
  "login.postcode": "Postleitzahl",
  "login.city": "Stadt",
  "login.name": "Name",
  "login.login-to-continue": "Einloggen, um fortzufahren.",

  "login.after-payment": "Sie können sich einloggen, während wir Ihre Zahlung überprüfen",
  "login.error": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "login.title": "Melden Sie sich an, um fortzufahren",
  "login.signing-in": "Anmelden...",
  "login.sign-in": "Anmelden",

  "settings.profile": "Profil",
  "settings.interface": "Benutzeroberfläche",
  "settings.subscription": "Abonnement",
  "settings.billingRenewsOn": "Ihr Abonnement verlängert sich am {{date}} (nächste Abbuchung).",
  "settings.billingEndsWithoutRenewal": "Sie haben Zugang bis zum {{date}}. Dieses Abonnement wird nicht automatisch verlängert.",
  "settings.billingAccessUntil": "Ihr Abonnementzugang ist gültig bis {{date}}.",
  "settings.billingIndefiniteAccess": "Ihr Abonnement hat kein geplantes Ende und keine automatische Verlängerung.",
  "settings.subscriptionInfo": "Ihr Abonnement ist {{subscriptionState}}",
  "settings.payments": "Zahlungen",
  "settings.download": "herunterladen",
  "settings.subscriptionStateUnknown": "Ihr Abonnementstatus ist unbekannt",
  "settings.cancelSubscription": "Abonnement kündigen",
  "settings.cancelSubscriptionShort": "Kündigen",
  "settings.save": "Speichern",
  "settings.lesson_templates": "Lektionsvorlagen",
  "settings.global_templates": "Globale Vorlagen",
  "settings.inputWarning": "Nicht erlaubt: {{input}}",
  "settings.subscribeTeaser": "Abonnieren Sie, um Zugang zu Voice Plans zu erhalten!",
  "settings.subscribeCta": "Jetzt abonnieren!",

  // UI Settings
  "ui.experimentalNavigation": "Experimentelle Navigation",
  "ui.currentlyUsingExperimental": "Sie verwenden derzeit unsere experimentelle Navigation mit verbesserter mobiler Unterstützung und modernem Design.",
  "ui.enableExperimental": "Aktivieren Sie unsere experimentelle Navigation für verbesserte mobile Unterstützung und modernes UI-Design.",
  "ui.enabled": "Aktiviert",
  "ui.disabled": "Deaktiviert",
  "ui.reloadNote": "Die Seite wird automatisch neu geladen, nachdem die Navigationseinstellungen geändert wurden, um die neue Benutzeroberfläche anzuwenden.",

  // New UI Teaser
  "teaser.title": "🚀 Probieren Sie Unsere Neue UI!",
  "teaser.subtitle": "Erleben Sie unser experimentelles Navigationslayout mit verbesserter Benutzerfreundlichkeit und modernem Design",
  "teaser.description": "Wir haben an einer völlig neuen Navigationserfahrung gearbeitet, die es einfacher macht:",
  "teaser.feature1": "✨ Zwischen verschiedenen Bereichen zu navigieren",
  "teaser.feature2": "📱 Die App auf mobilen Geräten zu verwenden",
  "teaser.feature3": "🎯 Schneller zu finden, was Sie suchen",
  "teaser.feature4": "🔄 Zwischen Voice Plans und Tools zu wechseln",
  "teaser.enableButton": "Neue Navigation Aktivieren",
  "teaser.note": "Dies aktiviert die experimentelle Navigation für Ihr Konto. Sie können sie später jederzeit in Ihren Einstellungen deaktivieren.",
  "teaser.success": "Erfolg! Neue Navigation erfolgreich aktiviert.",
  "teaser.reloadMessage": "Die Seite wird automatisch in wenigen Sekunden neu geladen, um die neue Benutzeroberfläche anzuzeigen...",
  "teaser.error": "Fehler:",
  "teaser.tryAgain": "Erneut Versuchen",

  // Voice Plan List Banner
  "banner.tryNewNavigation": "Probieren Sie unsere neue experimentelle Navigation!",
  "banner.improvedMobile": "Erleben Sie verbesserte mobile Navigation und modernes UI-Design. Kann auch über Einstellungen ⚙️ aktiviert werden.",
  "banner.tryNow": "Jetzt Probieren",

  // Purchase Flow
  "purchase.title": "Digitale Bücher Zugang",
  "purchase.subtitle": "Schalten Sie unsere komplette Bibliothek digitaler Bücher frei",
  "purchase.feature1": "Zugang zu allen digitalen Büchern",
  "purchase.feature2": "Hochwertige PDF-Leseerfahrung",
  "purchase.feature3": "Funktioniert auf allen Geräten",
  "purchase.feature4": "Neue Bücher werden regelmäßig hinzugefügt",
  "purchase.oneTime": "Einmalig",
  "purchase.getAccess": "Jetzt Zugang Erhalten",
  "purchase.alreadyHaveAccess": "Haben Sie bereits Zugang? Wenden Sie sich an den Support, wenn Sie Probleme beim Zugriff auf Ihre Bücher haben.",

  "errors.userNotFound": "Der ausgewählte Benutzer wurde nicht gefunden.",
  "errors.timeout": "Die Anfrage ist abgelaufen. Bitte versuchen Sie es später erneut.",
  "errors.sign_in_required": "Bitte melden Sie sich an, um fortzufahren.",
  "errors.user_exists": "Es wurde bereits ein Konto mit dieser E-Mail-Adresse gefunden.",

  "errors.awaitingPayment": "Sie können sich einloggen, sobald wir Ihre Zahlung erhalten haben",
  "payments.subscriptionName": "Universal Voice Abonnement",
  "payments.next": "nächste",
  "payments.previous": "vorherige",
  "payments.missing-a-payment": "Eine Zahlung verpasst?",
  "payments.retrieve-payments": "Zahlungen abrufen",
  "payments.no-payments": "Sie haben keine Zahlungen",
  "payments.payments": "Zahlungen",
  "payments.period": "Zeitraum",
  "payments.date": "Datum",
  "payments.noPayments": "Sie haben keine Zahlungen",
  "payment.noPayments": "Sie haben keine Zahlungen",
  "payment.pending.title": "Zahlung ausstehend",
  "payment.pending.message": "Ihre Abonnementzahlung wird verarbeitet. Dies kann je nach Zahlungsmethode einige Sekunden bis mehrere Tage dauern.",
  "payment.pending.waiting": "Warten auf Zahlungsbestätigung...",
  "payments.error": "Ein Fehler ist aufgetreten, bitte versuchen Sie es später erneut oder kontaktieren Sie den Support.",
  "payments.loading": "Zahlungen werden geladen...",
  "payments.generatingInvoices": "Generiere {{count}} Rechnungsnummern...",
  "payments.generatingInvoice": "Generiere Rechnung {{current}} von {{total}}...",
  "payments.syncing": "Zahlungen werden synchronisiert...",
  "subscription.expired": "Abgelaufen",
  "subscription.deleted": "Verwendet",
  "subscription.active": "Aktiv",
  "subscription.mollie.message.expired": "Ihr Abonnement ist abgelaufen, gehen Sie zu Ihrem Konto, um Ihr Abonnement zu verlängern.",
  "subscription.mollie.message.active": "Gültig bis {{endDate}}",
  "subscription.mollie.canceled": "Gekündigt",
  "subscription.mollie.name": "Premium",

  "subscription.school.message.expired": "Ihr Schulabonnement ist abgelaufen. Wenn dies nicht korrekt ist, wenden Sie sich bitte an den Vertreter Ihrer Schule.",
  "subscription.school.message.active": "Gültig bis {{endDate}}",
  "subscription.school.name": "Bildungs",

  "subscription.special.message.expired": "Ihr Sonderabonnement ist nicht mehr gültig, wenn dies nicht korrekt ist, wenden Sie sich bitte an den Kundendienst.",
  "subscription.special.message.active": "Ihr Sonderabonnement ist auf unbestimmte Zeit gültig.",
  "subscription.special.message.active.until": "Gültig bis {{endDate}}",
  "subscription.special.name": "Spezielles",
  "subscription.organization.name": "Organisationslizenz - {{orgName}}",
  "subscription.organization.message.active": "Aktiv über {{orgName}}",
  "subscription.organization.message.revoked": "Ihr Abonnementplatz wurde von Ihrer Organisation widerrufen.",
  "subscription.noSubscription": "Sie haben keine Abonnements",

  "migration.title": "Abrufen Ihres Kontos",
  "migration.check-payments": "Zahlungen überprüfen",
  "migration.check-subscriptions": "Abonnements überprüfen",
  "migration.check-ready": "Abrufen Ihres Kontos",
  "migration.no-payments": "Keine Zahlungen gefunden, es kann einige Minuten dauern, bis Ihre Zahlung verarbeitet wird. Wenn Sie bereits bezahlt haben und denken, dass dies ein Fehler ist, wenden Sie sich bitte an den Support.",
  "migration.no-subscriptions": "Keine Abonnements gefunden, es kann einige Minuten dauern, bis Ihr Abonnement verarbeitet wird. Wenn Sie denken, dass dies ein Fehler ist, wenden Sie sich bitte an den Support.",
  "migration.explanation": "Wir müssen Ihr Konto einmalig auf die neue Zahlungsplattform migrieren. Keine Sorge, Sie müssen nichts tun, wir bitten nur um ein wenig Geduld.",
  "migration.takesLong": "Dies dauert etwas länger als erwartet, aber wir sind fast fertig!",

  "checkout.help.email": "Ihre E-Mail-Adresse ist ausgefüllt, weil Sie eingeloggt sind.",
  "checkout.content.1": `Um das Portal auszuprobieren, schenken wir Ihnen die ersten <b class="has-text-primary">zwei Wochen</b>. Sie zahlen heute dafür €0.02. Sie können innerhalb von zwei Wochen kündigen oder weiterhin für den ausgewählten Zeitraum Gebrauch von unserem Portal machen. Die Abonnementgebühr wird erst nach zwei Wochen abgebucht.`,
  "checkout.content.1.discount": `Um das Portal auszuprobieren, schenken wir Ihnen die ersten <b class="has-text-primary">drei Monate</b>. Sie zahlen heute dafür €0.02. Sie können innerhalb von drei Monaten kündigen oder weiterhin für den ausgewählten Zeitraum Gebrauch von unserem Portal machen. Die Abonnementgebühr wird erst nach drei Monaten abgebucht.`,
  "checkout.content.1.dynamic": `Um das Portal auszuprobieren, schenken wir Ihnen die ersten <b class="has-text-primary">{{period}}</b>. Sie zahlen heute dafür €0.02. Sie können innerhalb von {{period}} kündigen oder weiterhin für den ausgewählten Zeitraum Gebrauch von unserem Portal machen. Die Abonnementgebühr wird erst nach {{period}} abgebucht.`,
  "checkout.content.2": "Schließen Sie jetzt ein Abonnement ab, damit Sie immer das Universal Voice Trainingsportal nutzen können!",
  "checkout.free": "Gratis",
  "checkout.monthly": "Pro Monat",
  "checkout.yearly": "Pro Jahr",
  "checkout.quarterly": "Alle 3 Monate",
  "checkout.name": "Name",
  "checkout.email": "E-Mail",
  "checkout.subscription": "Abonnement",
  "checkout.docent-code": "Referenzcode (optional)",
  "checkout.teacher-code-tooltip": "Wenn du Unterricht bei einem Universal Voice Teacher hast, hat dir diese Lehrkraft möglicherweise einen speziellen Code gegeben. Diesen kannst du hier eingeben. Falls du keinen erhalten hast, kein Problem – er ist für den weiteren Ablauf nicht erforderlich.",
  "checkout.referred-by-teacher": "Wurden Sie von einem unserer Lehrer weitergeleitet?",
  "checkout.teacher-code-explanation": "Wenn Sie einen Referenzcode von Ihrem Lehrer erhalten haben, geben Sie ihn hier ein.",
  "checkout.discount-code-placeholder": "RABATTCODE",
  "checkout.discount-code-validating": "Rabattcode wird überprüft...",
  "checkout.discount-code-invalid": "Ungültiger Rabattcode",
  "checkout.trial-period.one-week": "eine Woche",
  "checkout.trial-period.two-weeks": "zwei Wochen",
  "checkout.trial-period.weeks": "{{count}} Wochen",
  "checkout.trial-period.one-month": "einen Monat",
  "checkout.trial-period.two-months": "zwei Monate",
  "checkout.trial-period.three-months": "drei Monate",
  "checkout.trial-period.six-months": "sechs Monate",
  "checkout.trial-period.months": "{{count}} Monate",
  "checkout.trial-period.days": "{{count}} Tage",
  "checkout.discount.explanation.three-months": "Dieser Rabattcode verlängert Ihre Testphase auf drei Monate.",
  "checkout.to-payment": "Zur Zahlung",
  "checkout.without-subscription": "Konto ohne Abonnement erstellen",
  "checkout.password": "Password",

  "cookie.showPreferences": "Cookie Einstellungen anzeigen",

  "errors.auth/wrong-password": "Falsches Passwort. Bitte versuchen Sie es erneut.",
  "errors.auth/invalid-credential": "Ungültiges E-Mail-Adresse oder Passwort. Bitte versuchen Sie es erneut.",
  "errors.auth/quota-exceeded": "Sie haben Ihr Limit für Anmeldeversuche erreicht. Bitte versuchen Sie es später erneut.",
  "errors.auth/timeout": "Ihre Anmeldesitzung ist abgelaufen. Bitte erneut versuchen.",
  "errors.auth/too-many-requests": "Zu viele Anmeldeversuche. Bitte versuchen Sie es in ein paar Minuten erneut.",
  "errors.auth/unverified-email": "Bitte verifizieren Sie Ihre E-Mail-Adresse, um sich anzumelden.",
  "errors.auth/user-cancelled": "Der Anmeldevorgang wurde abgebrochen.",
  "errors.auth/user-not-found": "Kein Konto mit dieser E-Mail gefunden.",
  "errors.auth/user-disabled": "Ihr Konto wurde deaktiviert. Bitte wenden Sie sich an den Support.",
  "errors.auth/unknown": "Ein unbekannter Fehler ist aufgetreten ({{code}}). Bitte versuchen Sie es später erneut.",
  "errors.auth/missing-password": "Bitte geben Sie ein Passwort ein.",
  "errors.auth/missing-email": "Bitte geben Sie eine E-Mail-Adresse ein.",
  "checkout.discount-code": "Der folgende Rabattcode wird angewendet: {{code}}. Der Rabatt wird nach der Bezahlung Ihrer Abonnementgebühr aktiviert.",
  "checkout.account-type-title": "Wählen Sie Ihren Kontotyp",
  "registration.title": "Konto erstellen",
  "registration.subtitle": "Mach das Beste aus deiner Stimme",
  "registration.field.name": "NAME",
  "registration.field.email": "E-MAIL",
  "registration.field.password": "PASSWORT",
  "registration.field.docent-code": "LEHRER CODE",
  "registration.button.signup": "ANMELDEN",
  "registration.login-link.text": "Bereits Mitglied?",
  "registration.login-link.action": "Hier anmelden",
  "checkout.free-account-title": "Kostenloses Konto",
  "checkout.paid-account-title": "Bezahltes Konto",
  "checkout.free-description": "Nur Konto, Zugang zu digitalen Büchern (In-App-Kauf möglicherweise erforderlich)",
  "checkout.paid-benefit-1": "Persönliche Voice Plans",
  "checkout.paid-benefit-2": "Zugang zu allen Übungen",
  "checkout.paid-benefit-3": "Zugang zum Portal",
  "checkout.create-free-account": "Kostenloses Konto erstellen",
  "checkout.choose-subscription": "Abonnement wählen",
  "checkout.can-upgrade-later": "Sie können später jederzeit auf ein bezahltes Konto upgraden",
  "checkout.free-account-selected": "Kostenloses Konto ausgewählt",
  "checkout.free-account-description": "Sie erstellen ein kostenloses Konto ohne Abonnement. Sie können jederzeit später upgraden.",
  "checkout.payment-acknowledgment": "Ich verstehe und stimme zu, dass nach der kostenlosen Testphase automatisch die gewählte Abonnementgebühr berechnet wird",
  "checkout.payment-acknowledgment-help": "Durch das Ankreuzen dieses Kästchens bestätigen Sie, dass Sie die Bedingungen verstehen und zustimmen, dass wir nach Ende der Testphase automatisch die Abonnementkosten gemäß Ihrem gewählten Tarif berechnen.",
  "checkout.payment-acknowledgment-required": "Sie müssen der automatischen Abrechnung nach der Testphase zustimmen",
  "checkout.back-to-options": "Zurück zu den Optionen",
  "checkout.subscription-required-message": "Sie benötigen ein Abonnement für diese Funktion",
  "checkout.subscription-required": "Bitte wählen Sie einen Abonnementplan",
  "checkout.choose-subscription-plan": "Wählen Sie Ihren Abonnementplan",
  "checkout.click-to-subscribe": "Klicken Sie, um zu abonnieren",
  "checkout.payment-complete-sign-in": "Zahlung abgeschlossen! Melden Sie sich an, um fortzufahren.",
  "checkout.waiting-for-payment": "Warten auf Zahlung",
  "checkout.payment-processing": "Ihre Zahlung wird verarbeitet. Dies kann einen Moment dauern.",
  "checkout.checking-subscription": "Abonnementstatus wird überprüft...",
  "checkout.payment-timeout": "Die Zahlungsbestätigung dauert länger als erwartet. Sie können diese Seite schließen und später Ihr Konto überprüfen.",
  "checkout.retry-check": "Ausstehende Zahlung prüfen",
  "checkout.processing": "Wird verarbeitet...",
  "checkout.do-not-refresh": "Aktualisieren oder schließen Sie diese Seite nicht, während die Zahlung verarbeitet wird.",
  "checkout.payment-canceled-title": "Zahlung abgebrochen",
  "checkout.payment-canceled-desc": "Sie haben die Zahlung abgebrochen. Es wurden keine Gebühren erhoben.",
  "checkout.payment-failed-title": "Zahlung fehlgeschlagen",
  "checkout.payment-failed-desc": "Die Zahlung konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut oder wählen Sie eine andere Zahlungsmethode.",
  "checkout.payment-expired-title": "Zahlungssitzung abgelaufen",
  "checkout.payment-expired-desc": "Die Zeit zum Abschließen der Zahlung ist abgelaufen. Bitte versuchen Sie es erneut.",
  "checkout.try-again": "Erneut versuchen",
  "checkout.back-to-checkout": "Zurück zur Abonnementsauswahl",
  "checkout.banner-canceled": "Ihre vorherige Zahlung wurde abgebrochen. Wählen Sie ein Abonnement, um es erneut zu versuchen.",
  "checkout.banner-failed": "Ihre vorherige Zahlung ist leider fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "checkout.banner-expired": "Ihre vorherige Zahlungssitzung ist abgelaufen. Bitte versuchen Sie es erneut.",
  "audioplayer.playback-rate": "Wählen Sie die Wiedergabegeschwindigkeit, eine Zahl zwischen 0.1 und 4.0",
  "audioplayer.audio-player": "Audioplayer",
  "audioplayer.seek": "Suchen",
  "audioplayer.pause": "Pause",
  "audioplayer.play": "Abspielen",
  "audioplayer.replay": "Erneut abspielen",
  "audioplayer.repeat": "Wiederholen",
  "audioplayer.transpose-down": "Tiefer transponieren",
  "audioplayer.transpose-up": "Höher transponieren",
  "audioplayer.mute": "Stummschalten",
  "audioplayer.unmute": "Ton einschalten",
  "audioplayer.volume": "Lautstärke",

  "lessonTemplateListItem.namePrompt": "Geben Sie einen Namen für diese Vorlage ein",
  "lessonTemplateListItem.confirm-remove": "Sind Sie sicher, dass Sie diese Vorlage löschen möchten?",
  "login.needs-password-reset": "Ihr Passwort muss zurückgesetzt werden, bitte überprüfen Sie Ihre E-Mail für einen Link zum Zurücksetzen Ihres Passworts.",

  // PDF Viewer Gesture Hints
  "pdf.gesture.tap-left": "Tippen um zurück zu gehen",
  "pdf.gesture.tap-right": "Tippen um vorwärts zu gehen",
  "pdf.gesture.tap-center": "Tippen um Werkzeugleiste zu zeigen",

  "verifyEmail.title": "E-Mail-Adresse bestätigen",
  "verifyEmail.subtitle": "Eine Bestätigungs-E-Mail wurde an <strong>{{email}}</strong> gesendet. Bitte klicken Sie auf den Link in der E-Mail, um fortzufahren.",
  "verifyEmail.checkSpam": "Wenn Sie die E-Mail nicht sehen, überprüfen Sie bitte Ihren Spam-Ordner.",
  "verifyEmail.resendButton": "Bestätigungs-E-Mail erneut senden",
  "verifyEmail.resendSuccess": "Bestätigungs-E-Mail gesendet!",
  "verifyEmail.resendError": "Fehler beim Senden der Bestätigungs-E-Mail. Bitte versuchen Sie es später erneut.",
  "verifyEmail.processing": "Ihre Zahlung wird vorbereitet...",

  // Book Selector
  "books.title": "Digitale Bücher",
  "books.subtitle": "Wählen Sie ein Buch zum Lesen",
  "books.owned": "Besessen",
  "books.purchasePending": "Kauf ausstehend",
  "books.pendingMessage": "Ihr Kauf wird bearbeitet. Bitte warten Sie.",
  "books.pendingDetails": "Ihre Zahlung ist derzeit ausstehend. Je nach Zahlungsmethode kann dies mehrere Tage dauern. Wenn Sie sicher sind, dass Sie die Zahlung nicht abgeschlossen haben, können Sie erneut versuchen zu kaufen.",
  "books.purchase": "Kaufen - €{{price}}",
  "books.tapForPayment": "Tippen Sie für Zahlungsoptionen",
  "books.processing": "Wird verarbeitet...",
  "books.close": "Schließen",
  "books.one-time": "einmalig",
  "books.get-access": "Jetzt Zugang erhalten",
  "books.access-description": "Schalten Sie unsere komplette Bibliothek digitaler Bücher frei",
  "books.digital-books": "Digitale Bücher",
  "books.all-singing-exercises": "Alle Gesangsübungen",
  "books.pdf-music-sheets": "PDF-Notenblätter",
  "books.audio-files": "Audiodateien mit Übungen",
  "books.video-exercises": "Video-Übungen",
  "books.practice-tools": "Übungswerkzeuge",
  "books.purchase-error": "Bei dem Kauf ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  "books.buy-for": "Kaufen für €{{price}}",
  "books.confirm-purchase": "Kauf bestätigen",

  // PDF Viewer Tutorial
  "pdf.tutorial.welcome.title": "Willkommen im Reader",
  "pdf.tutorial.welcome.content": "Lassen Sie uns einen kurzen Rundgang machen.",
  "pdf.tutorial.zones.title": "Navigationszonen",
  "pdf.tutorial.zones.content": "Links tippen um zurückzugehen, rechts um vorwärts zu gehen, oder Mitte für das Menü.",
  "pdf.tutorial.toc.title": "Inhaltsverzeichnis",
  "pdf.tutorial.toc.content": "Hier tippen, um Kapitel anzuzeigen und zu bestimmten Abschnitten zu springen.",
  "pdf.tutorial.search.title": "Suchen",
  "pdf.tutorial.search.content": "Finden Sie bestimmten Text im Dokument.",
  "pdf.tutorial.offline.title": "Offline-Zugriff",
  "pdf.tutorial.offline.content": "Laden Sie das Dokument für schnelleres Laden und Offline-Lesen herunter.",
  "pdf.tutorial.view.title": "Ansichtsoptionen",
  "pdf.tutorial.view.content": "Wechseln Sie zwischen Einzelseiten- und Doppelseitenansicht.",
  "pdf.tutorial.visual.title": "Visuelle Steuerelemente",
  "pdf.tutorial.visual.content": "Rein-/Rauszoomen oder zwischen Scrollen und Umblättern wechseln.",
  "pdf.tutorial.zone.previous": "Zurück",
  "pdf.tutorial.zone.menu": "Menü / Zoom",
  "pdf.tutorial.zone.next": "Weiter",
  "pdf.tutorial.action.skip": "Überspringen",
  "pdf.tutorial.action.prev": "Zurück",
  "pdf.tutorial.action.next": "Weiter",
  "pdf.tutorial.action.finish": "Fertig",
  "pdf.tutorial.dont_show": "Nicht mehr anzeigen",

  // PDF Cache Controls
  "pdf.cache.download_pdf": "PDF Herunterladen",
  "pdf.cache.benefit_text": "Das Herunterladen sorgt dafür, dass Seiten sofort schneller laden.",
  "pdf.cache.updating": "Aktualisieren...",
  "pdf.cache.downloaded_percentage": "% Heruntergeladen",
  "pdf.cache.pages": "Seiten",
  "pdf.cache.ready_offline": "Bereit für den Offline-Einsatz",
  "pdf.cache.download_full": "Vollständiges PDF Herunterladen",
  "pdf.cache.download_tooltip": "Herunterladen für schnelleres Laden",
  "pdf.cache.manage_downloads": "Downloads Verwalten",
  "pdf.cache.remove_download": "Download Entfernen",
  "pdf.cache.storage_used": "Gesamtspeicher Verwendet:",
  "pdf.cache.clear_all": "Alles Löschen",
  "pdf.cache.downloading_pages": "Seiten werden heruntergeladen...",
  "pdf.cache.processing": "Verarbeiten...",
  "pdf.cache.error_info_unavailable": "Download nicht möglich: PDF-Informationen nicht verfügbar",
  "pdf.cache.confirm_download": "Alle {{total}} Seiten herunterladen? Dies sorgt für reibungsloses Lesen und Offline-Zugriff.",
  "pdf.cache.success_download": "Erfolgreich {{total}} Seiten heruntergeladen!",
  "pdf.cache.error_download": "Download fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "pdf.cache.confirm_remove": "Download für dieses PDF entfernen?",
  "pdf.cache.error_clear": "Cache konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.",
  "pdf.cache.confirm_clear_all": "ALLE Downloads entfernen? Dadurch werden alle heruntergeladenen PDFs von diesem Gerät entfernt.",
  "pdf.cache.already_downloaded": "Alle Seiten wurden bereits heruntergeladen.",
  "pdf.cache.storage_full": "Dieses Gerät oder Safari hat nicht genug Speicher für den Rest des Buchs. Lösche alte Downloads oder gib Speicherplatz auf dem iPad frei.",
  "pdf.cache.partial_download": "{{saved}} von {{total}} Seiten gespeichert.",
  "pdf.cache.confirm_download_space": "Etwa {{needed}} benötigt, {{remaining}} verfügbar.",

  // PDF Toolbar
  "pdf.toolbar.back": "Zurück",
  "pdf.toolbar.by": "von",
  "pdf.toolbar.zoom_out": "Verkleinern",
  "pdf.toolbar.zoom_reset": "Zoom zurücksetzen",
  "pdf.toolbar.zoom_in": "Vergrößern",
  "pdf.toolbar.downloaded": "Heruntergeladen",
  "pdf.toolbar.download": "Herunterladen",
  "pdf.toolbar.search": "Suchen",

  // Fast PDF Viewer
  "pdf.loading_config": "Dokumentkonfiguration wird geladen...",
  "pdf.debug.mode": "Debug-Modus",
  "pdf.debug.info": "Debug-Info",
  "pdf.debug.status": "Status",
  "pdf.debug.scrolling": "Scrollen",
  "pdf.debug.current_page": "Aktuelle Seite",
  "pdf.debug.scale": "Maßstab",
  "pdf.debug.download_queue": "Download-Warteschlange ({{active}} aktiv, {{pending}} ausstehend)",
  "pdf.debug.render_queue": "Render-Warteschlange (Prioritätsreihenfolge)",
  "pdf.chapters.title": "Kapitel",
  "pdf.controls.zoom_out": "Verkleinern",
  "pdf.controls.zoom_in": "Vergrößern",
  "pdf.controls.continuous": "Kontinuierlicher Scroll-Modus",
  "pdf.controls.scroll": "Scrollen",
  "pdf.controls.paginated": "Seitenmodus",
  "pdf.controls.page_flip": "Umblättern",
  "pdf.controls.lock_interface": "Schnittstelle für Leistung sperren",
  "pdf.controls.unlock_interface": "Schnittstelle entsperren",
  "pdf.loading.page": "Seite {{page}} wird geladen...",
  "pdf.loading.waiting": "Seite {{page}} - Warten auf Netzwerk... ",
  "pdf.loading.downloading": "Seite {{page}} - Herunterladen... {{percent}}%",
  "pdf.loading.opening": "Seite {{page}} - Dokument wird geladen...",
  "pdf.loading.rendering": "Seite {{page}} - Rendern... {{percent}}%",
  "pdf.loading.failed": "Seite {{page}} - Rendern fehlgeschlagen",
  "pdf.loading.document": "Dokument wird geladen...",
  "pdf.stamping": "Die Lizenz für dieses Gerät wird erneuert. Einen Moment Geduld…",
  "pdf.stamping_hint": "Das passiert nur, wenn das Buch neu auf diesem Gerät ist oder aktualisiert wurde.",
  "pdf.confirm.title": "Das Buch auf dieses Gerät herunterladen?",
  "pdf.confirm.body": "Das Buch ist etwa {{size}} MB groß. Es wird auf diesem Gerät gespeichert und öffnet sich danach sofort, auch offline.",
  "pdf.confirm.update_title": "Eine neue Version des Buches ist verfügbar",
  "pdf.confirm.update_body": "Der Download umfasst etwa {{size}} MB. Bis dahin können Sie die Version auf diesem Gerät weiterlesen.",
  "pdf.confirm.metered": "Bei einer mobilen oder getakteten Verbindung ist WLAN vielleicht die bessere Wahl.",
  "pdf.confirm.download": "Herunterladen ({{size}} MB)",
  "pdf.confirm.not_now": "Nicht jetzt",
  "pdf.confirm.keep_current": "Aktuelle Version behalten",
  "pdf.confirm.declined": "Das Buch wurde noch nicht heruntergeladen.",
  "pdf.confirm.download_now": "Jetzt herunterladen",
  "pdf.downloading": "Buch wird heruntergeladen... {{percent}}%",
  "pdf.no_access": "Sie haben keinen Zugriff auf dieses Buch.",
  "pdf.load_failed": "Das Buch konnte nicht geladen werden. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  "pdf.exercise.not_found": "Übung nicht gefunden.",
  "pdf.exercise.no_audio": "Diese Übung hat kein Audio.",
  "pdf.exercise.label": "Übung",
  "pdf.exercise.minimize": "Player verkleinern",
  "pdf.exercise.expand": "Player öffnen",
  "pdf.exercise.close": "Schließen",
  "pdf.debug.yes": "Ja",
  "pdf.debug.no": "Nein",

  // PDF Search
  "pdf.search.placeholder": "In PDF suchen...",
  "pdf.search.searching": "Suchen...",
  "pdf.search.results": "{{current}} von {{total}}",
  "pdf.search.no_results": "Keine Ergebnisse",
  "pdf.search.previous_tooltip": "Vorheriges Ergebnis (Shift+Enter)",
  "pdf.search.next_tooltip": "Nächstes Ergebnis (Enter)",
  "pdf.search.close_tooltip": "Suche schließen (Escape)",

  // Chapter Navigator
  "pdf.navigator.toggle": "Kapitelnavigation umschalten",
  "pdf.navigator.page_of": "Seite {{current}} von {{total}}",
  "pdf.navigator.pages_range": "Seiten {{start}}-{{end}}",

  // Portal
  "portal.title": "Portal",
  "portal.language": "Sprache",
  "portal.unpublished_changes": "Nicht veröffentlichte Änderungen",
  "portal.published": "Veröffentlicht",
  "portal.publishing": "Veröffentlichen...",
  "portal.publish": "Veröffentlichen",
  "portal.disable_edit": "Bearbeitungsmodus deaktivieren",
  "portal.enable_edit": "Bearbeitungsmodus aktivieren",
  "portal.loading": "Portal-Inhalt wird geladen...",
  "portal.retry": "Erneut versuchen",
  "portal.no_sections": "Keine Abschnitte",
  "portal.section_title": "Abschnittstitel",
  "portal.version_history": "Versionsverlauf",
  "portal.hide": "Ausblenden",
  "portal.loading_versions": "Laden...",
  "portal.no_versions": "Keine früheren Versionen",
  "portal.restore": "Wiederherstellen",
  "portal.show_version_history": "Versionsverlauf anzeigen",
  "portal.saving": "Speichern...",
  "portal.save": "Speichern",
  "portal.cancel": "Abbrechen",
  "portal.no_content": "Kein Inhalt",
  "portal.select_section": "Wählen Sie ein Kapitel und einen Abschnitt",
  "portal.add_chapter": "Kapitel hinzufügen",
  "portal.add_section": "Abschnitt hinzufügen",
  "portal.close": "Schließen",
  "portal.save_ordering": "Reihenfolge speichern",
  "portal.sections": "Abschnitte",

  "redirect.title": "Neue Webadresse",
  "redirect.message": "Das Universal Voice Portal ist auf eine neue Adresse umgezogen! Sie verwenden derzeit eine alte Domain.",
  "redirect.login_notice": "Sobald Sie auf OK klicken, leiten wir Sie zur neuen Adresse weiter. Möglicherweise müssen Sie sich erneut anmelden.",
  "redirect.ok": "OK",

  "passkey.sign_in": "Mit Passkey anmelden",
  "passkey.register": "Konto mit Passkey erstellen",
  "passkey.manage_title": "Passkeys verwalten",
  "passkey.manage_desc": "Fügen Sie einen Passkey hinzu, um sich schnell und sicher ohne Passwort anzumelden.",
  "passkey.add": "Passkey hinzufügen",
  "passkey.name_placeholder": "Passkey-Name (z.B. 'Mein Telefon')",
  "passkey.default_name": "Mein Passkey",
  "passkey.error": "Passkey-Fehler: {{error}}",
  "passkey.error.not_allowed": "Abgebrochen oder Zeitüberschreitung.",
  "passkey.error.already_registered": "Dieser Passkey ist auf diesem Gerät bereits registriert.",
  "passkey.error.not_supported": "Nicht unterstützt auf diesem Gerät oder Browser.",
  "passkey.error.security": "Kann nur über eine sichere Verbindung (HTTPS) verwendet werden.",
  "passkey.error.no_matching_credential": "Nicht erkannt oder gehört nicht zu diesem Konto.",
  "passkey.error.account_exists": "Mit dieser E-Mail-Adresse existiert bereits ein Konto. Melden Sie sich zuerst an und fügen Sie dann in Ihren Kontoeinstellungen einen Passkey hinzu.",
  "passkey.code.label": "Code aus Ihrer E-Mail",
  "passkey.code.sent": "Wir haben einen 6-stelligen Code an {{email}} gesendet. Geben Sie ihn ein, um Ihren Passkey zu erstellen.",
  "passkey.code.create": "Passkey erstellen",
  "passkey.code.email_required": "Geben Sie zuerst Ihre E-Mail-Adresse ein.",
  "passkey.error.invalid_code": "Dieser Code ist nicht korrekt. Prüfen Sie die E-Mail und versuchen Sie es erneut.",
  "passkey.error.code_expired": "Dieser Code ist abgelaufen oder wurde zu oft versucht. Fordern Sie einen neuen Code an.",
  "passkey.error.code_wait": "Bitte warten Sie eine Minute, bevor Sie einen neuen Code anfordern.",
  "passkey.error.expired_challenge": "Sitzung abgelaufen. Bitte erneut versuchen.",
  "passkey.error.unauthorized": "Nicht autorisiert. Bitte melden Sie sich erneut an.",

  "passkey.no_passkeys": "Noch keine Passkeys hinzugefügt.",

  "login.no-password-set": "Wenn Sie sich mit einem Passkey angemeldet haben, nutzen Sie bitte die Option 'Mit Passkey anmelden' oben.",
  "registration.passkey-info": "Die Anmeldung mit einem Passkey legt kein Passwort fest. Möchten Sie später ein Passwort hinzufügen? Nutzen Sie die Option 'Passwort vergessen' auf der Anmeldeseite.",
  "stemprofiel.title": "Stimmenprofil",
  "stemprofiel.updated-days": "Aktualisiert vor {{n}} Tagen",
  "stemprofiel.updated-today": "Heute aktualisiert",
  "stemprofiel.updated-yesterday": "Gestern aktualisiert",
  "stemprofiel.updated-never": "Noch nicht ausgefüllt",
  "stemprofiel.filled": "{{n}}/9 ausgefüllt",
  "stemprofiel.mode-current": "Aktuell",
  "stemprofiel.mode-goal": "Ziel",
  "stemprofiel.footer-filled": "{{n}} von 9 Dimensionen ausgefüllt",
  "stemprofiel.reset": "Löschen",
  "stemprofiel.save": "Speichern",
  "stemprofiel.saved-toast": "Stimmenprofil gespeichert",
  "stemprofiel.reset-toast": "Profil gelöscht",
  "stemprofiel.reset-confirm": "Alle ausgefüllten Werte löschen?",
  "tutorial.action.skip": "Überspringen",
  "tutorial.action.prev": "Zurück",
  "tutorial.action.next": "Weiter",
  "tutorial.action.finish": "Fertigstellen",
  "tutorial.dont_show": "Nicht mehr anzeigen",
  "tutorial.cancel_confirm": "Möchten Sie die Einführung wirklich abbrechen?",
  "tutorial.settings.title": "Tutorials & Hilfe",
  "tutorial.settings.reset_all": "Alle Tutorials zurücksetzen",
  "tutorial.settings.reset_success": "Tutorials erfolgreich zurückgesetzt!",
  "tutorial.manage_tags.intro.title": "Tags verwalten",
  "tutorial.manage_tags.intro.content": "Willkommen in der Tag-Verwaltung! Hier können Sie Tags organisieren und anpassen, um Ihre Voice Plans zu kategorisieren.",
  "tutorial.manage_tags.create.title": "Neue Tags erstellen",
  "tutorial.manage_tags.create.content": "Geben Sie hier einen Tag-Namen ein und drücken Sie die Eingabetaste oder klicken Sie auf die '+'-Schaltfläche, um einen neuen Tag zu erstellen.",
  "tutorial.manage_tags.favorite.title": "An Navigation anheften",
  "tutorial.manage_tags.favorite.content": "Klicken Sie auf das Stern-Symbol, um Tags anzuheften. Angeheftete Tags erscheinen als Schnellfilter-Tabs auf Ihrem Dashboard.",
  "tutorial.manage_tags.color.title": "Farben anpassen",
  "tutorial.manage_tags.color.content": "Klicken Sie auf den Farbkreis, um eine benutzerdefinierte Farbe für diesen Tag auszuwählen. Die Tags und Tabs übernehmen diese Farbe.",
  "tutorial.manage_tags.edit.title": "Tags umbenennen",
  "tutorial.manage_tags.edit.content": "Klicken Sie auf das Stift-Symbol, um den Anzeigenamen eines Tags zu ändern. Angeheftete Tabs zeigen diesen Namen.",
  "tutorial.manage_tags.system.title": "System-Tags",
  "tutorial.manage_tags.system.content": "Aktivieren Sie dieses Kontrollkästchen, um reservierte Tags (wie Schüler und Lehrer) auszublenden und sich auf Ihre eigenen Tags zu konzentrieren.",
  "tutorial.dashboard.quick_filters.title": "Konfigurierbare Schnellfilter",
  "tutorial.dashboard.quick_filters.content": "Willkommen auf Ihrem neuen Voice Plans Dashboard! Angeheftete Tags erscheinen nun hier als Schnellfilter-Tabs, damit Sie sofort wechseln können.",
  "tutorial.dashboard.tab_all.title": "Alle Voice Plans",
  "tutorial.dashboard.tab_all.content": "Der Tab 'Alle' bleibt immer hier, um Ihnen eine vollständige Übersicht über all Ihre Voice Plans an einem Ort zu geben.",
  "tutorial.dashboard.search_btn.title": "Nach Name suchen",
  "tutorial.dashboard.search_btn.content": "Tippen Sie auf das Suchsymbol, um ein Suchfeld einzublenden und Ihre Voice Plans nach Name zu filtern.",
  "tutorial.dashboard.gear_btn.title": "Tags verwalten",
  "tutorial.dashboard.gear_btn.content": "Tippen Sie auf das Zahnrad-Symbol, um die Tag-Verwaltung zu öffnen. Hier erstellen Sie neue Tags, legen Farben fest und wählen, welche Tags als Schnellfilter-Tabs oben erscheinen (Stern-Symbol).",
  "tutorial.dashboard.tag_toggles.title": "Mehrfach-Tag-Filterung",
  "tutorial.dashboard.tag_toggles.content": "Aktivieren Sie einen oder mehrere Tags in dieser Leiste, um Ihre Voice Plans zu filtern. Nur Pläne mit diesen Tags werden angezeigt.",
  "tutorial.dashboard.edit_tags.title": "Voice-Plan-Tags bearbeiten",
  "tutorial.dashboard.edit_tags.content": "Wir haben den Tag-Editor für diesen Voice Plan geöffnet. Klicken Sie auf Tags, um sie direkt hinzuzufügen oder zu entfernen. Halten Sie einen Voice Plan lang gedrückt, um dieses Menü zu öffnen.",
  "faq.tours.title": "Interaktive Führungen",
  "faq.tours.intro": "Brauchen Sie eine kurze Einführung? Starten Sie eine interaktive Führung, die Ihnen die Anwendung in Echtzeit zeigt.",
  "faq.tours.dashboard.title": "Dashboard-Einführung",
  "faq.tours.dashboard.description": "Erfahren Sie, wie die neuen Schnellfilter, konfigurierbaren Tabs und Tag-Optionen funktionieren.",
  "faq.tours.dashboard.button": "Führung starten",
  "faq.tours.tags.title": "Tag-Manager-Anleitung",
  "faq.tours.tags.description": "Lernen Sie, wie Sie Tags erstellen, färben, umbenennen und an Ihre Dashboard-Navigation anheften.",
  "faq.tours.tags.button": "Anleitung starten",

  "tutorial.create_vp.step1_intro.title": "Einen Voice Plan erstellen",
  "tutorial.create_vp.step1_intro.content": "Lassen Sie uns einen neuen Voice Plan erstellen. Diese Tour führt Sie Schritt für Schritt durch den Prozess.",
  "tutorial.create_vp.step1_name.title": "Name des Voice Plans",
  "tutorial.create_vp.step1_name.content": "Geben Sie einen aussagekräftigen Namen für Ihren Voice Plan ein, z.B. 'Belting-Fortschritt von Hans' oder 'Mein klassisches Training'.",
  "tutorial.create_vp.step1_next.title": "Nächster Schritt",
  "tutorial.create_vp.step1_next.content": "Klicken Sie hier, um zum nächsten Schritt zu gelangen und Tags hinzuzufügen.",
  "tutorial.create_vp.step2_tags.title": "Mit Tags organisieren",
  "tutorial.create_vp.step2_tags.content": "Fügen Sie Tags hinzu, um Ihre Voice Plans später einfacher zu organisieren und zu filtern. Geben Sie einen Tag ein und drücken Sie die Eingabetaste.",
  "tutorial.create_vp.step2_quick.title": "Schnelle Kategorien",
  "tutorial.create_vp.step2_quick.content": "Sie können auch schnell Ihre bevorzugten angehefteten Tags hinzufügen, indem Sie hier darauf klicken.",
  "tutorial.create_vp.step2_next.title": "Weiter",
  "tutorial.create_vp.step2_next.content": "Klicken Sie hier, um Ihren neuen Voice Plan zu überprüfen.",
  "tutorial.create_vp.step3_review.title": "Details überprüfen",
  "tutorial.create_vp.step3_review.content": "Nehmen Sie sich einen Moment Zeit, um zu überprüfen, ob der Name und die ausgewählten Tags korrekt sind.",
  "tutorial.create_vp.step3_submit.title": "Plan erstellen",
  "tutorial.create_vp.step3_submit.content": "Klicken Sie hier, um Ihren neuen Voice Plan endgültig in der Datenbank zu erstellen.",
  "tutorial.create_vp.step4_invite.title": "Personen einladen",
  "tutorial.create_vp.step4_invite.content": "Sie können diesen Voice Plan optional mit anderen teilen, indem Sie deren E-Mail-Adresse eingeben. Sie erhalten dann eine Einladung zum Beitritt.",
  "tutorial.create_vp.step4_done.title": "Alles fertig!",
  "tutorial.create_vp.step4_done.content": "Klicken Sie hier, um die Tour zu beenden und Ihren neu erstellten Voice Plan zu öffnen!",

  "faq.tours.create_vp.title": "Voice-Plan-Erstellung Tour",
  "faq.tours.create_vp.description": "Schritt-für-Schritt-Anleitung zur Erstellung eines neuen Voice Plans, zum Hinzufügen von Tags und zum Einladen anderer Personen.",
  "faq.tours.create_vp.button": "Tour starten",

  "tutorial.playlist_list.intro.title": "Wiedergabelisten-Bibliothek",
  "tutorial.playlist_list.intro.content": "Willkommen bei Ihren Wiedergabelisten! Hier können Sie benutzerdefinierte Übungseinheiten mit Übungen erstellen.",
  "tutorial.playlist_list.create.title": "Wiedergabeliste erstellen",
  "tutorial.playlist_list.create.content": "Klicken Sie auf diese Schaltfläche, um eine neue Wiedergabeliste zu erstellen. Sie werden aufgefordert, einen Namen einzugeben.",
  "tutorial.playlist_detail.intro.title": "Ihre Wiedergabeliste",
  "tutorial.playlist_detail.intro.content": "Dies ist die Detailansicht Ihrer Wiedergabeliste. Hier können Sie die Audioelemente in Ihrer Übungsroutine verwalten und nacheinander abspielen.",
  "tutorial.playlist_detail.edit.title": "Wiedergabeliste bearbeiten",
  "tutorial.playlist_detail.edit.content": "Aktivieren Sie den Bearbeitungsmodus, um Ihre Wiedergabeliste anzupassen. Hier können Sie Elemente hinzufügen, löschen oder per Drag-and-Drop neu anordnen.",
  "tutorial.playlist_detail.add_item.title": "Audioelemente hinzufügen",
  "tutorial.playlist_detail.add_item.content": "Klicken Sie hier, um Gesangsübungen zu Ihrer Wiedergabeliste hinzuzufügen.",
  "tutorial.playlist_detail.share.title": "Wiedergabeliste teilen",
  "tutorial.playlist_detail.share.content": "Klicken Sie hier, um diese Wiedergabeliste mit anderen zu teilen. Sie können sie öffentlich machen oder direkt mit Lehrern und Schülern teilen.",
  "faq.tours.playlist.title": "Wiedergabelisten-Anleitung",
  "faq.tours.playlist.description": "Lernen Sie, wie Sie eine Wiedergabeliste erstellen, Übungen hinzufügen, neu anordnen und teilen.",
  "faq.tours.playlist.button": "Wiedergabelisten-Tour starten",
  "admin.impersonating": "Benutzer {{name}} imitieren",
  "admin.stop-impersonation": "Imitation beenden",

  "organization.title": "Organisationslizenz",
  "organization.create.subtitle": "Erwerben Sie einen Pool von Abonnementplätzen für Ihre Schule, Ihr Unternehmen oder Ihren Chor. Verwalten Sie alle Lizenzen, Mitglieder und Verlängerungen in einem zentralen Portal.",
  "organization.create.name_label": "Name der Organisation",
  "organization.create.name_placeholder": "z. B. Königliche Musikakademie",
  "organization.create.seats_label": "Anzahl der Plätze (mind. 10)",
  "organization.create.interval_label": "Abrechnungsintervall",
  "organization.create.interval_monthly": "Monatlich (€9,95 / Platz / Monat)",
  "organization.create.interval_yearly": "Jährlich (€99,50 / Platz / Jahr - 2 Monate kostenlos!)",
  "organization.create.submit": "Erstellen & Weiter zur Verifizierungszahlung",
  "organization.create.note": "Hinweis: Sie werden zu Mollie weitergeleitet, um Ihre Zahlung abzuschließen. Zukünftige Abonnementsgebühren werden automatisch abgebucht.",
  "organization.create.modal_title": "Neue Organisationslizenz",
  "organization.create.modal_subtitle": "Erwerben Sie einen Pool von Abonnementplätzen für Ihr Team.",
  "organization.create.modal_submit": "Erstellen & Weiter",
  "organization.dashboard.active_organization": "Aktive Organisation",
  "organization.dashboard.title": "Organisations-Dashboard",
  "organization.dashboard.new_organization": "Neue Organisation",
  "organization.dashboard.admin_label": "Administrator: {{email}}",
  "organization.dashboard.manage_admins": "Administratoren verwalten",
  "organization.dashboard.billing_details": "Abrechnungsdetails",
  "organization.dashboard.view_invoices_and_details": "Rechnungen & Abrechnungsdetails",
  "organization.invoices.title": "Rechnungen & Abrechnungsdetails",
  "organization.invoices.subtitle": "Verwalten Sie Ihre Rechnungsadresse, USt-IdNr. und Handelsregisternummer und sehen Sie alle Rechnungen ein.",
  "organization.invoices.billing_form_title": "Abrechnungsdetails & Adresse",
  "organization.invoices.billing_form_desc": "Legen Sie die Daten fest, die auf Ihren offiziellen Rechnungen erscheinen.",
  "organization.invoices.company_name": "Firmenname auf der Rechnung",
  "organization.invoices.billing_email": "Rechnungs-E-Mail-Adresse",
  "organization.invoices.billing_email_help": "Rechnungen und Zahlungsbestätigungen werden automatisch an diese Adresse gesendet.",
  "organization.invoices.street": "Straße und Hausnummer",
  "organization.invoices.postcode": "Postleitzahl",
  "organization.invoices.city": "Stadt",
  "organization.invoices.country": "Land",
  "organization.invoices.kvk_number": "Handelsregisternummer (optional)",
  "organization.invoices.vat_number": "USt-IdNr. (optional)",
  "organization.invoices.save_button": "Abrechnungsdetails speichern",
  "organization.invoices.save_success": "Abrechnungsdetails erfolgreich aktualisiert.",
  "organization.invoices.list_title": "Rechnungsübersicht",
  "organization.invoices.no_invoices": "Noch keine Rechnungen verfügbar.",
  "organization.invoices.invoice_nr": "Rechnungs-Nr.",
  "organization.invoices.date": "Datum",
  "organization.invoices.description": "Beschreibung",
  "organization.invoices.amount": "Betrag",
  "organization.invoices.download_pdf": "PDF herunterladen",
  "organization.dashboard.billing_desc_monthly": "Monatliche Organisationslizenz",
  "organization.dashboard.billing_desc_yearly": "Jährliche Organisationslizenz",
  "organization.dashboard.price_per_seat": "Preis pro Platz: €{{price}}",
  "organization.dashboard.next_renewal": "Nächste Verlängerung: {{date}}",
  "organization.dashboard.pending_downgrade_notice": "Eine Reduzierung auf {{count}} Sitzplätze ist für das nächste Verlängerungsdatum ({{date}}) geplant.",
  "organization.dashboard.seat_usage": "Sitzplatznutzung",
  "organization.dashboard.seats_assigned": "von {{total}} Plätzen zugewiesen",
  "organization.dashboard.seats_remaining": "{{count}} Plätze übrig",
  "organization.dashboard.assignment_movements": "{{count}} Zuweisungsbewegungen",
  "organization.dashboard.modify_seats": "Sitzplatzanzahl ändern",
  "organization.dashboard.modify_seats_desc": "Erhöhen oder verringern Sie den Gesamtpool an Plätzen. Die Verringerung darf die Anzahl der zugewiesenen Plätze ({{usedSeats}}) nicht unterschreiten.",
  "organization.dashboard.enterprise_seats_managed": "Die Platzanzahl für Enterprise-Lizenzen wird von Universal Voice verwaltet. Kontaktieren Sie Ihren Account Manager, um die Anzahl der Plätze zu ändern.",
  "organization.dashboard.enterprise_seats_title": "Platzkontingent",
  "organization.dashboard.update_button": "Aktualisieren",
  "organization.dashboard.seat_assignments": "Sitzplatzzuweisungen",
  "organization.dashboard.users": "Benutzer",
  "organization.dashboard.no_users": "Noch keine Benutzer zugewiesen.",
  "organization.dashboard.assign_seat_button": "Sitzplatz zuweisen",
  "organization.dashboard.assign_seat_placeholder": "nutzer@beispiel.de",
  "organization.dashboard.seat_id": "Sitzplatz-ID",
  "organization.dashboard.assigned_user": "Zugewiesener Benutzer",
  "organization.dashboard.date_assigned": "Zuweisungsdatum",
  "organization.dashboard.action": "Aktion",
  "organization.dashboard.pending_signup": "Ausstehende Registrierung",
  "organization.dashboard.unassigned": "Nicht zugewiesen (Freier Platz)",
  "organization.dashboard.revoke_seat": "Sitzplatz entziehen",
  "organization.dashboard.ready": "Bereit",
  "organization.dashboard.search_seats_placeholder": "Sitz nach E-Mail-Adresse oder ID suchen...",
  "organization.dashboard.clear_search": "Suche löschen",
  "organization.dashboard.search_prompt": "Geben Sie eine E-Mail-Adresse oder ID ein, um einen bestimmten Sitz zu suchen und zu verwalten.",
  "organization.dashboard.no_seats_found": "Keine Sitze gefunden, die der Suchanfrage entsprechen.",
  "organization.admins.title": "Administratoren verwalten",
  "organization.admins.subtitle": "Verwalten Sie, wer die Lizenz dieser Organisation verwalten und Plätze zuweisen kann.",
  "organization.admins.add_admin": "Administrator hinzufügen",
  "organization.admins.email_address": "E-Mail-Adresse",
  "organization.admins.role": "Rolle",
  "organization.admins.action": "Aktion",
  "organization.admins.owner": "Besitzer",
  "organization.admins.co_admin": "Co-Admin",
  "organization.admins.remove": "Entfernen",
  "common.error": "Fehler",
  "admin.organizations.title": "Organisationen",
  "admin.organizations.create_enterprise": "Neue Enterprise-Organisation",
  "admin.organizations.search_placeholder": "Nach Name, E-Mail oder ID suchen...",
  "admin.organizations.name": "Name",
  "admin.organizations.type": "Typ",
  "admin.organizations.status": "Status",
  "admin.organizations.admins": "Administratoren",
  "admin.organizations.seats": "Plätze",
  "admin.organizations.actions": "Aktionen",
  "admin.organizations.activate": "Aktivieren",
  "admin.organizations.suspend": "Sperren",
  "admin.organizations.active": "Aktiv",
  "admin.organizations.suspended": "Gesperrt",
  "admin.organizations.pending": "Zahlung ausstehend",
  "admin.organizations.enterprise": "Enterprise",
  "admin.organizations.mollie_monthly": "Mollie Monatlich",
  "admin.organizations.mollie_yearly": "Mollie Jährlich",
  "admin.organizations.create_modal_title": "Neue Enterprise-Organisation erstellen",
  "admin.organizations.create_modal_desc": "Erstellen Sie eine Enterprise-Organisation. Enterprise-Lizenzen werden manuell außerhalb von Mollie abgerechnet.",
  "admin.organizations.admin_email_label": "Administrator-E-Mail (bestehender Benutzer)",
  "admin.organizations.seats_label": "Anzahl der Plätze",
  "admin.organizations.edit_seats": "Plätze anpassen",
  "admin.organizations.no_orgs_found": "Keine Organisationen gefunden",
  "admin.organizations.total_orgs": "Organisationen insgesamt",
  "admin.organizations.total_seats": "Plätze insgesamt",
  "admin.organizations.active_seats": "Zugewiesene Plätze",
  "admin.email_templates.title": "System-E-Mail-Ereignisse",
  "admin.email_templates.subtitle": "Konfigurieren Sie E-Mail-Vorlagen und aktive Versionen für Systemereignisse.",
  "admin.email_templates.search_placeholder": "Nach Name, ID, Kategorie oder Beschreibung suchen...",
  "admin.email_templates.event": "Ereignis",
  "admin.email_templates.category": "Kategorie",
  "admin.email_templates.active_version": "Aktive Version",
  "admin.email_templates.languages": "Sprachen",
  "admin.email_templates.actions": "Aktionen",
  "admin.email_templates.no_events_found": "Keine E-Mail-Vorlagen gefunden",
  "admin.email_templates.history": "Verlauf",
  "admin.email_templates.edit_template": "Vorlage Bearbeiten",
  "admin.email_templates.not_configured": "Nicht konfiguriert",
  "organization.list.subtitle": "Verwalten Sie Ihre Organisationslizenzen und zugewiesenen Plätze",
  "organization.list.back_to_list": "Zurück zu Organisationen",

  "pricing.title": "Geben Sie Ihrer Stimme Raum Zum Wachsen",
  "pricing.subtitle": "Ob Sie zu Hause üben, Gesangsunterricht nehmen oder einen Chor leiten. Digital PVP bietet die perfekte Anleitung und Gesangsübungen jederzeit.",
  "pricing.billing.monthly": "Monatlich",
  "pricing.billing.quarterly": "Vierteljährlich",
  "pricing.billing.yearly": "Jährlich",
  "pricing.billing.save_percent": "Sparen Sie {{percent}}%",
  "pricing.billing.guarantee": "14 Tage Kostenlos Testen • Keine Kreditkarte Erforderlich",

  "pricing.value.v1_title": "Frei Einsingen & Üben",
  "pricing.value.v1_desc": "Üben Sie in Ihrem eigenen Tempo und Ihrer Tonhöhe",
  "pricing.value.v2_title": "Universal Voice Guide",
  "pricing.value.v2_desc": "Offizielle Lehrbücher und Techniken immer zur Hand",
  "pricing.value.v3_title": "Stimmprofil & Fortschritt",
  "pricing.value.v3_desc": "Verfolgen Sie Stimmumfang und Entwicklung",
  "pricing.value.v4_title": "Lehrer-Übungspläne",
  "pricing.value.v4_desc": "Erhalten Sie individuelle Übungspläne von Ihrem Gesangslehrer",

  "pricing.free.title": "Kostenloses Konto",
  "pricing.free.badge": "KOSTENLOS STARTEN",
  "pricing.free.price": "€0",
  "pricing.free.period": "unverbindlich testen",
  "pricing.free.description": "Perfekt für den Einstieg. Erhalten Sie eine Auswahl an Standard-Aufwärmplänen zum Ausprobieren.",
  "pricing.free.cta": "Kostenloses Konto Erstellen",
  "pricing.free.f1": "Standard-Probepläne zum Einsingen (Kostenlose Kategorie)",
  "pricing.free.f2": "Zugang zu kostenlosen Basis-Aufwärmübungen",
  "pricing.free.f3": "Üben über den Webbrowser auf jedem Gerät",

  "pricing.pro.title": "Pro Abonnement",
  "pricing.pro.badge_yearly": "AM BELIEBTESTEN • BESTER WERT",
  "pricing.pro.badge_quarterly": "SCHLAUE WAHL",
  "pricing.pro.badge_monthly": "FLEXIBLES ABONNEMENT",
  "pricing.pro.description": "Unbegrenzter Zugriff auf alle Gesangsübungen, individuelle Übungspläne Ihres Lehrers und tägliche Trainingswerkzeuge.",
  "pricing.pro.cta": "14 Tage Kostenlos Testen",
  "pricing.pro.f1": "Erhalten & Nutzen von Übungsplänen Ihres Gesangslehrers",
  "pricing.pro.f2": "Unbegrenztes Abspielen aller Gesangsübungen",
  "pricing.pro.f3": "Passen Sie Tempo und Tonhöhe an Ihre Stimme an",
  "pricing.pro.f4": "Vollständige digitale Universal Voice Guide Bücher (PDF)",
  "pricing.pro.f5": "Erstellen Sie unbegrenzt eigene Voice Plans & Playlists",
  "pricing.pro.f6": "Persönliches Stimmprofil erstellen & Fortschritt verfolgen",
  "pricing.pro.f7": "Prioritäts-Support bei allen Fragen",

  "pricing.matrix.title": "Alle Funktionen Im Vergleich",
  "pricing.matrix.cat_basics": "Basis & Aufwärmübungen",
  "pricing.matrix.cat_exercises": "Gesangsübungen & Audio",
  "pricing.matrix.cat_plans": "Übungspläne & Unterricht",
  "pricing.matrix.cat_books": "Lehrbücher & PDFs",
  "pricing.matrix.cat_apps": "Apps & Offline-Nutzung",
  "pricing.matrix.item_starter_exercises": "Kostenlose Aufwärmübungen",
  "pricing.matrix.item_all_exercises": "Vollständiger Übungskatalog",
  "pricing.matrix.item_pitch_tempo": "Tempo & Tonhöhe anpassen",
  "pricing.matrix.item_starter_plans": "Standard-Probepläne (Kostenlose Kategorie)",
  "pricing.matrix.item_teacher_plans": "Übungspläne Ihres Gesangslehrers erhalten",
  "pricing.matrix.item_create_plans": "Eigene Voice Plans & Playlists erstellen",
  "pricing.matrix.item_stemprofiel": "Persönliches Stimmprofil erstellen & verfolgen",
  "pricing.matrix.item_book_previews": "Vorschauseiten ausgewählter Bücher",
  "pricing.matrix.item_full_books": "Alle Universal Voice Guide Bücher (PDF)",
  "pricing.matrix.item_offline_apps": "Offline-Übungsmodus (Mobil & Desktop)",
  "pricing.matrix.val_limited": "Basisauswahl",
  "pricing.matrix.val_full": "Vollständiger Zugriff",
  "pricing.matrix.val_previews": "Kein Zugriff",
  "pricing.matrix.val_all_books": "Alle Bücher",
  "pricing.matrix.val_default_only": "Nur Standard-Probepläne",
  "pricing.matrix.val_teacher_unlimited": "Vollständig (Lehrer & Eigene)",
  "pricing.matrix.val_unlimited": "Unbegrenzt Erstellen",
  "pricing.matrix.val_online_only": "Nur Online",
  "pricing.matrix.val_full_offline": "Vollständig Offline",
  "pricing.matrix.val_no_access": "Nicht enthalten",
  "pricing.matrix.val_pro_only": "Nur bei Pro",

  "pricing.org_teaser.title": "Bringen Sie Ihren Chor oder Ihre Schule Voran",
  "pricing.org_teaser.subtitle": "Arbeiten Sie mit Ihren Schülern oder Chormitgliedern zusammen. Teilen Sie Übungspläne, verwalten Sie Lizenzen zentral und nutzen Sie Gruppenrabatte.",
  "pricing.org_teaser.cta": "Organisations-Lizenzen Ansehen",
  "pricing.faq.title": "Häufig Gestellte Fragen Zu Preisen",
  "pricing.faq.q1": "Kann ich mein Abonnement jederzeit kündigen?",
  "pricing.faq.a1": "Ja, absolut! Sie können Ihr Abonnement mit einem Klick in Ihren Kontoeinstellungen kündigen. Sie behalten den vollen Zugriff bis zum Ende Ihres bezahlten Abrechnungszeitraums.",
  "pricing.faq.q2": "Wie funktioniert die 14-tägige kostenlose Testphase?",
  "pricing.faq.a2": "Wenn Sie Ihre Testphase starten, erhalten Sie sofort 14 Tage Zugriff auf alle Pro-Funktionen. Sie können Übungen testen, Wiedergabelisten erstellen und digitale Bücher einsehen. Die Abrechnung erfolgt erst nach 14 Tagen, wenn Sie Ihr Abonnement fortsetzen möchten.",
  "pricing.faq.q3": "Auf welchen Geräten kann ich Digital PVP nutzen?",
  "pricing.faq.a3": "Digital PVP ist über Ihren Webbrowser auf allen Ihren Geräten zugänglich: Smartphone, Tablet, Laptop oder Desktop-Computer.",
  "pricing.faq.q4": "Was ist der Unterschied zwischen einem kostenlosen Konto und einem Pro-Abonnement?",
  "pricing.faq.a4": "Mit einem kostenlosen Konto nutzen Sie eine Auswahl an Standard-Probeplänen. Um individuelle Übungspläne Ihres Gesangslehrers oder Chorleiters zu empfangen, Ihr Stimmprofil zu verwalten und eigene Pläne zu erstellen, ist ein Pro-Abonnement oder eine Organisationslizenz erforderlich.",

  "pricing_org.title": "Organisations- & Institutionen-Lizenzen",
  "pricing_org.subtitle": "Statten Sie Ihren Chor, Ihr Gesangsstudio, Ihre Musikschule oder Ihr Konservatorium mit Mehrfachlizenzen, geteilten Lehrplänen und Verwaltungsfunktionen aus.",
  "pricing_org.switch_individual": "Suchen Sie nach einem Einzelabonnement? Zu den Einzelplänen",
  "pricing_org.tier_ensemble.title": "Kleiner Chor & Ensemble",
  "pricing_org.tier_ensemble.seats": "5 – 15 Mitgliederlizenzen",
  "pricing_org.tier_ensemble.price": "€4,50",
  "pricing_org.tier_ensemble.period": "pro Lizenz / Monat (jährliche Abrechnung)",
  "pricing_org.tier_ensemble.desc": "Ideal für Gesangsgruppen, Quartette und kleine Chöre, die gemeinsam üben.",
  "pricing_org.tier_ensemble.cta": "Gruppenlizenz Starten",
  "pricing_org.tier_school.title": "Musikschule & Gesangsstudio",
  "pricing_org.tier_school.badge": "EMPFOHLEN FÜR SCHULEN",
  "pricing_org.tier_school.seats": "16 – 50 Lizenzen (Lehrer & Schüler)",
  "pricing_org.tier_school.price": "€3,50",
  "pricing_org.tier_school.period": "pro Lizenz / Monat (jährliche Abrechnung)",
  "pricing_org.tier_school.desc": "Vollständige Gesangsumgebung mit Schülerzuweisung, geteilten Voice Plans und zentraler Abrechnung.",
  "pricing_org.tier_school.cta": "Musikschule Einrichten",
  "pricing_org.tier_enterprise.title": "Konservatorium & Enterprise",
  "pricing_org.tier_enterprise.badge": "ENTERPRISE STUFE",
  "pricing_org.tier_enterprise.seats": "50+ Lizenzen / Unbegrenzte Skalierung",
  "pricing_org.tier_enterprise.price": "Individueller Preis",
  "pricing_org.tier_enterprise.period": "maßgeschneiderte Bedingungen & Abrechnung",
  "pricing_org.tier_enterprise.desc": "Für Konservatorien, Gesangsabteilungen an Universitäten, große Chorverbände und Großinstitutionen.",
  "pricing_org.tier_enterprise.cta": "Enterprise-Kontakt Aufnehmen",
  "pricing_org.features.title": "Vorteile von Organisationslizenzen",
  "pricing_org.features.f1": "Zentrales Verwaltungs-Dashboard für Mitgliedslizenzen",
  "pricing_org.features.f2": "Erstellen & Zuweisen von eigenen Voice Plans und Übungen an Schüler",
  "pricing_org.features.f3": "Geteilte Repertoire-Bibliotheken & Ensemble-Proben-Playlists",
  "pricing_org.features.f4": "Flexible zentrale Abrechnung, Bestellnummer-Unterstützung & MwSt.-Rechnungen",
  "pricing_org.features.f5": "Dedizierter Account Manager & Onboarding-Unterstützung",
  "pricing_org.features.f6": "Optionen für benutzerdefiniertes SSO & LMS-Integration",
  "pricing_org.form.title": "Enterprise-Team Kontaktieren",
  "pricing_org.form.subtitle": "Füllen Sie das Formular aus und unser Team meldet sich innerhalb von 24 Stunden mit einem maßgeschneiderten Angebot.",
  "pricing_org.form.org_name": "Name der Organisation",
  "pricing_org.form.contact_name": "Ansprechpartner",
  "pricing_org.form.email": "Geschäftliche E-Mail-Adresse",
  "pricing_org.form.seats": "Geschätzte Anzahl der Lizenzen",
  "pricing_org.form.type": "Art der Organisation",
  "pricing_org.form.type_choir": "Chor / Gesangsgruppe",
  "pricing_org.form.type_school": "Gesangsstudio / Musikschule",
  "pricing_org.form.type_conservatory": "Konservatorium / Universität",
  "pricing_org.form.type_other": "Sonstige Institution",
  "pricing_org.form.message": "Teilen Sie uns Ihre Anforderungen mit",
  "pricing_org.form.submit": "Enterprise-Anfrage Absenden",
  "pricing_org.form.success_title": "Anfrage Erhalten!",
  "pricing_org.form.success_desc": "Vielen Dank für Ihre Anfrage. Ein Spezialist von Universal Voice wird sich in Kürze bei Ihnen melden.",

  "pricing.head.title": "Preise & Übersicht - Digital PVP",
  "pricing.head.description": "Wählen Sie den passenden Tarif für Ihre Stimme und Ziele. Kostenlos starten oder 14 Tage gratis testen.",
  "pricing.nav.individual": "Einzelpersonen",
  "pricing.nav.organization": "Chöre & Einrichtungen",
  "pricing.billing.monthly_period": "/ Mon",
  "pricing.billing.monthly_note": "Monatlich kündbar",
  "pricing.billing.quarterly_note": "€18,00 vierteljährlich abgerechnet (-14%)",
  "pricing.billing.yearly_note": "€60,00 jährlich abgerechnet (-28%)",
  "pricing.billing.best_deal": "-28% • Bester Wert",
  "pricing.billing.savings_badge": "Sparen Sie {{amount}}",
  "pricing.billing.savings_yearly": "Sie sparen €24 pro Jahr (28% Rabatt)",
  "pricing.billing.savings_quarterly": "Sie sparen €12 pro Jahr (14% Rabatt)",
  "pricing.billing.savings_monthly": "Maximale Flexibilität • Monatlich kündbar",
  "pricing.audio.tooltip": "Klangbeispiel der Plattform anhören",
  "pricing.audio.pause": "Klang pausieren",
  "pricing.audio.play": "Klangharmonie anhören",
  "pricing.free.sub": "Ideal zum Entdecken",
  "pricing.free.no_payment": "Keine Zahlungsdaten oder Verpflichtungen erforderlich",
  "pricing.free.includes": "In Kostenlos enthalten:",
  "pricing.pro.sub": "Für ambitionierte Sänger & Studenten",
  "pricing.pro.includes": "Alles aus Kostenlos plus:",
  "pricing.trust.trial": "14 Tage Unverbindlich Testen",
  "pricing.trust.cancel": "Jederzeit Kündbar",
  "pricing.trust.secure": "Sicher per iDEAL, Kreditkarte & Apple Pay",
  "pricing.matrix.subtitle": "Vergleichen Sie alle Funktionen und finden Sie das perfekte Paket",
  "pricing.matrix.search_placeholder": "Funktion suchen...",
  "pricing.matrix.clear_search": "Suche löschen",
  "pricing.matrix.filter_all": "Alle",
  "pricing.matrix.filter_plans": "Übungspläne",
  "pricing.matrix.filter_exercises": "Übungen",
  "pricing.matrix.header_feature": "Funktion",
  "pricing.matrix.empty_search": "Keine Funktionen gefunden für \"{{query}}\"",
  "pricing.matrix.tooltip.starter_plans": "Erhalten Sie digitale Übungspläne direkt von Ihrem Lehrer zugewiesen",
  "pricing.matrix.tooltip.teacher_plans": "Nutzen Sie alle Lektionsstrukturen der Universal Voice Methode",
  "pricing.matrix.tooltip.create_plans": "Erstellen Sie Ihre eigenen personalisierten Einsing- und Übungsroutinen",
  "pricing.matrix.tooltip.starter_exercises": "Kostenlose Auswahl an Basis-Einsingübungen",
  "pricing.matrix.tooltip.all_exercises": "Zugang zum vollständigen Archiv von über 500+ Gesangsübungen",
  "pricing.matrix.tooltip.pitch_tempo": "Ändern Sie Tonart und Tempo im Player passend zu Ihrem Stimmumfang",
  "pricing.matrix.tooltip.stemprofiel": "Erfassen Sie Ihren Stimmumfang, Stimmtyp und persönliche Gesangsziele",
  "pricing.matrix.tooltip.books_access": "Digitale Universal Voice Guide Handbücher enthalten",
  "pricing.org_teaser.badge": "Chöre & Schulen",
  "pricing.faq.subtitle": "Antworten auf die am häufigsten gestellten Fragen",
  "pricing_org.head.title": "Organisationslizenzen & Enterprise - Digital PVP",
  "pricing_org.head.description": "Gruppenlizenzen für Chöre, Gesangsstudios, Musikschulen und Konservatorien. Verwalten Sie mehrere Lizenzen, geteilte Übungspläne und zentrale Abrechnung.",
  "pricing_org.tier_ensemble.f1": "5 bis 15 Mitgliederlizenzen mit Pro-Zugang",
  "pricing_org.tier_ensemble.f2": "Zentrales Administratorkonto für Dirigent/Leiter",
  "pricing_org.tier_ensemble.f3": "Geteilte Chor-Wiedergabelisten & Voice Plans",
  "pricing_org.tier_ensemble.f4": "Jährliche automatische Abrechnung",
  "pricing_org.tier_school.f1": "16 bis 50 Studenten- & Lehrerlizenzen",
  "pricing_org.tier_school.f2": "Weisen Sie Studenten Voice Plans und Aufgaben zu",
  "pricing_org.tier_school.f3": "Mehrere Lehrerkonten & Administratoren",
  "pricing_org.tier_school.f4": "Flexible Hinzufügung von Lizenzen im Laufe des Jahres",
  "pricing_org.tier_school.f5": "Prioritäts-E-Mail-Support",
  "pricing_org.tier_enterprise.f1": "50+ bis unbegrenzte Lizenzen",
  "pricing_org.tier_enterprise.f2": "Individuelles SSO (Single Sign-On) & LMS-Anbindung",
  "pricing_org.tier_enterprise.f3": "Eigenes Curriculum & Gesangsmaterial digitalisieren",
  "pricing_org.tier_enterprise.f4": "Rechnungsstellung auf Konto (PO / Invoicing)",
  "pricing_org.tier_enterprise.f5": "Dedicated Account Manager & SLA-Vereinbarungen",
  "pricing_org.features.f1_title": "Zentrale Verwaltung",
  "pricing_org.features.f2_title": "Voice Plans Zuweisen",
  "pricing_org.features.f3_title": "Geteiltes Repertoire",
  "pricing_org.features.f4_title": "Flexible Abrechnung",
  "pricing_org.features.f5_title": "Dedizierter Support",
  "pricing_org.features.f6_title": "SSO & LMS Optionen",
  "pricing_org.form.org_name_placeholder": "Z.B. Hochschule für Musik",
  "pricing_org.form.contact_name_placeholder": "Name",
  "pricing_org.form.email_placeholder": "email@organisation.de",
  "pricing_org.form.seats_15_50": "15 – 50 Lizenzen",
  "pricing_org.form.seats_50_100": "50 – 100 Lizenzen",
  "pricing_org.form.seats_100_250": "100 – 250 Lizenzen",
  "pricing_org.form.seats_250_plus": "250+ Lizenzen (Unbegrenzt)",
  "pricing_org.form.message_placeholder": "Beschreiben Sie die Wünsche oder spezifischen Fragen für Ihre Einrichtung...",
  "pricing_org.form.submitting": "Senden...",
  "pricing_org.calc.badge": "Interaktiver Lizenz-Rechner",
  "pricing_org.calc.title": "Berechnen Sie die Kosten für Ihre Organisation",
  "pricing_org.calc.seats_label": "Lizenzen",
  "pricing_org.calc.recommended_tier": "Empfohlenes Paket",
  "pricing_org.calc.rate_per_seat": "Tarif pro Lizenz",
  "pricing_org.calc.per_month": "/ Mon",
  "pricing_org.calc.savings_label": "Rabatt vs Einzel",
  "pricing_org.calc.savings_note": "({{savings}}/Jahr Ersparnis)",
  "pricing_org.trust.central_management": "Zentrale Mitgliederverwaltung",
  "pricing_org.trust.invoice_po": "Rechnungskauf (PO)",
  "pricing_org.trust.instant_allocation": "Sofortige Lizenzvergabe",
  "pricing_org.trust.gdpr": "DSGVO-Konform",
  "pricing_org.features.subtitle": "Entwickelt für Dirigenten, Gesangslehrer und Bildungsadministratoren.",
  "pricing_org.faq.q1": "Wie funktioniert die Zuweisung von Mitgliedslizenzen?",
  "pricing_org.faq.a1": "Als Administrator erhalten Sie Zugriff auf ein zentrales Dashboard. Sie können Mitglieder per E-Mail einladen oder CSV-Listen importieren. Lizenzen können jederzeit übertragen werden.",
  "pricing_org.faq.q2": "Können wir per offizieller Rechnung (PO) bezahlen?",
  "pricing_org.faq.a2": "Ja! Für Chöre, Musikschulen und Konservatorien bieten wir Zahlung auf Rechnung mit offiziellen MwSt.-Rechnungen und Bestellnummern (PO) an.",
  "pricing_org.faq.q3": "Können Lehrer und Dirigenten eigene Voice Plans teilen?",
  "pricing_org.faq.a3": "Absolut. Lehrer und Dirigenten können maßgeschneiderte Aufwärmroutinen und Chor-Playlists direkt allen Mitgliedern oder bestimmten Stimmgruppen zuweisen.",
  "pricing_org.faq.q4": "Was passiert, wenn wir unterjährig zusätzliche Lizenzen benötigen?",
  "pricing_org.faq.a4": "Sie können jederzeit weitere Lizenzen über das Dashboard hinzufügen. Die Kosten werden anteilig für die verbleibende Laufzeit berechnet.",
  "common.select_language": "Sprache auswählen",
  "booklinks.title": "Übungslinks",
  "booklinks.choose_book": "Wähle ein Buch, um seine Übungslinks zu prüfen.",
  "booklinks.review_only": "Nur zu prüfen",
  "booklinks.count": "{{total}} Links, {{review}} zu prüfen",
  "booklinks.save": "Speichern",
  "booklinks.saved": "Gespeichert",
  "booklinks.unsaved": "Ungespeicherte Änderungen",
  "booklinks.save_failed": "Speichern fehlgeschlagen.",
  "booklinks.load_failed": "Die Links konnten nicht geladen werden.",
  "booklinks.detect": "Erneut erkennen",
  "booklinks.detect_failed": "Die Erkennung konnte nicht gestartet werden.",
  "booklinks.detect_unsaved": "Die Erkennung ersetzt die automatischen Links. Ungespeicherte Änderungen verwerfen?",
  "booklinks.job.pending": "Erkennung in der Warteschlange…",
  "booklinks.job.processing": "Links werden erkannt…",
  "booklinks.job.completed": "Erkennung fertig, Links neu geladen.",
  "booklinks.job.failed": "Erkennung fehlgeschlagen.",
  "booklinks.add_box": "Feld auf Seite {{page}} hinzufügen",
  "booklinks.delete": "Link löschen",
  "booklinks.exercise": "Übung",
  "booklinks.search": "Nach Nummer oder Name suchen",
  "booklinks.unknown_exercise": "Unbekannte Übung",
  "booklinks.page": "Seite {{page}}",
  "booklinks.status.ok": "OK",
  "booklinks.status.review": "Zu prüfen",
  "booklinks.empty": "Keine Links.",
  "booklinks.rect": "Feld (PDF-Punkte, von links unten)",
  "booklinks.select_hint": "Wähle einen Link in der Liste oder auf einer Seite, um ihn zu bearbeiten, oder ziehe auf einer Seite, um einen neuen zu zeichnen.",
  "booklinks.book_admin": "Buch und Kapitel",
  "booklinks.replace_pdf": "PDF ersetzen",
  "booklinks.replace_confirm": "Das Ersetzen der PDF macht sie für alle zum aktuellen Buch. Fortfahren?",
  "booklinks.publishing": "Wird veröffentlicht…",
  "booklinks.replace_failed": "Die PDF konnte nicht ersetzt werden.",
  "booklinks.chapters": "Kapitel",
  "booklinks.chapters_upload_first": "Lade zuerst eine PDF hoch; bis dahin gilt die mitgelieferte Kapitelliste.",
  "booklinks.chapter_title": "Kapiteltitel",
  "booklinks.chapter_start": "Startseite",
  "booklinks.chapter_add": "Kapitel hinzufügen"
}
